import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = { context: { clientName: "lol" } } as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: { [key: string]: any };
  UnixTimestamp: any;
  UnixTimestampSec: any;
};

export type AddPaymentMethodResult = {
  __typename?: "AddPaymentMethodResult";
  error?: Maybe<Scalars["String"]>;
  paymentMethod?: Maybe<RecurlyPaymentMethod>;
  success?: Maybe<Scalars["Boolean"]>;
};

export type AllPlayerRank = {
  __typename?: "AllPlayerRank";
  exodiaUuid?: Maybe<Scalars["String"]>;
  rankScores?: Maybe<Array<Maybe<RankScore>>>;
  riotTagLine?: Maybe<Scalars["String"]>;
  riotUserName?: Maybe<Scalars["String"]>;
};

export type ArenaPlacements = {
  __typename?: "ArenaPlacements";
  _1: Scalars["Int"];
  _2: Scalars["Int"];
  _3: Scalars["Int"];
  _4: Scalars["Int"];
  _5: Scalars["Int"];
  _6: Scalars["Int"];
  _7: Scalars["Int"];
  _8: Scalars["Int"];
};

export type Attachment = {
  content: Scalars["String"];
  filename: Scalars["String"];
};

export type BannedChamp = {
  __typename?: "BannedChamp";
  championId?: Maybe<Scalars["Int"]>;
  pickTurn?: Maybe<Scalars["Int"]>;
  teamId?: Maybe<Scalars["Int"]>;
};

export type BasicChampionPerformance = {
  __typename?: "BasicChampionPerformance";
  assists?: Maybe<Scalars["Int"]>;
  championId?: Maybe<Scalars["Int"]>;
  cs?: Maybe<Scalars["Int"]>;
  damage?: Maybe<Scalars["Int"]>;
  damageTaken?: Maybe<Scalars["Int"]>;
  deaths?: Maybe<Scalars["Int"]>;
  doubleKills?: Maybe<Scalars["Int"]>;
  firstPlace?: Maybe<Scalars["Int"]>;
  gold?: Maybe<Scalars["Int"]>;
  kills?: Maybe<Scalars["Int"]>;
  lpAvg?: Maybe<Scalars["Int"]>;
  matchupStats?: Maybe<Array<Maybe<MatchupStatistics>>>;
  maxDeaths?: Maybe<Scalars["Int"]>;
  maxKills?: Maybe<Scalars["Int"]>;
  pentaKills?: Maybe<Scalars["Int"]>;
  quadraKills?: Maybe<Scalars["Int"]>;
  totalMatches?: Maybe<Scalars["Int"]>;
  totalPlacement?: Maybe<Scalars["Int"]>;
  tripleKills?: Maybe<Scalars["Int"]>;
  wins?: Maybe<Scalars["Int"]>;
};

export type BasicChampionPerformanceWithTier = {
  __typename?: "BasicChampionPerformanceWithTier";
  assists?: Maybe<Scalars["Int"]>;
  championId?: Maybe<Scalars["Int"]>;
  cs?: Maybe<Scalars["Int"]>;
  damage?: Maybe<Scalars["Int"]>;
  damageTaken?: Maybe<Scalars["Int"]>;
  deaths?: Maybe<Scalars["Int"]>;
  doubleKills?: Maybe<Scalars["Int"]>;
  gold?: Maybe<Scalars["Int"]>;
  kills?: Maybe<Scalars["Int"]>;
  lpAvg?: Maybe<Scalars["Int"]>;
  lpCount?: Maybe<Scalars["Int"]>;
  maxDeaths?: Maybe<Scalars["Int"]>;
  maxKills?: Maybe<Scalars["Int"]>;
  pentaKills?: Maybe<Scalars["Int"]>;
  pickRate?: Maybe<Scalars["Float"]>;
  quadraKills?: Maybe<Scalars["Int"]>;
  role?: Maybe<Scalars["Int"]>;
  tier?: Maybe<Scalars["String"]>;
  totalMatches?: Maybe<Scalars["Int"]>;
  tripleKills?: Maybe<Scalars["Int"]>;
  visionScore?: Maybe<Scalars["Int"]>;
  wins?: Maybe<Scalars["Int"]>;
  zScore?: Maybe<Scalars["Float"]>;
};

export type BillingData = {
  __typename?: "BillingData";
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  isActive?: Maybe<Scalars["Boolean"]>;
  subscription?: Maybe<PaymentSubscription>;
  upcomingInvoice?: Maybe<UpcomingInvoice>;
};

export type BillingSettings = {
  __typename?: "BillingSettings";
  creditCards?: Maybe<Array<Maybe<CreditCard>>>;
  paypal?: Maybe<Paypal>;
};

export type BraintreeClientToken = {
  __typename?: "BraintreeClientToken";
  clientToken?: Maybe<Scalars["String"]>;
  success?: Maybe<Scalars["String"]>;
};

export type BraintreeSubscription = {
  __typename?: "BraintreeSubscription";
  balance?: Maybe<Scalars["String"]>;
  billingDayOfMonth?: Maybe<Scalars["Int"]>;
  billingPeriodEndDate?: Maybe<Scalars["String"]>;
  billingPeriodStartDate?: Maybe<Scalars["String"]>;
  failureCount?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["String"]>;
  nextBillingDate?: Maybe<Scalars["String"]>;
  price?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  updatedAt?: Maybe<Scalars["String"]>;
};

export type CancelSubscriptionResponse = {
  __typename?: "CancelSubscriptionResponse";
  error?: Maybe<Scalars["String"]>;
  subscription?: Maybe<SubscriptionInfo>;
  success: Scalars["Boolean"];
};

export type ChampSelectLiveGame = {
  __typename?: "ChampSelectLiveGame";
  champSelectTags?: Maybe<Array<Maybe<ChampSelectTags>>>;
  lastTenWinrate?: Maybe<LastTenWinrate>;
  premadeList?: Maybe<Array<Maybe<RiotIdOutput>>>;
  recentRoleRates?: Maybe<RecentRoleRates>;
  riotTagLine?: Maybe<Scalars["String"]>;
  riotUserName?: Maybe<Scalars["String"]>;
};

export type ChampSelectTags = {
  __typename?: "ChampSelectTags";
  champId: Scalars["Int"];
  tagList?: Maybe<Array<Maybe<Tag>>>;
};

export type Champion = {
  __typename?: "Champion";
  championId: Scalars["Int"];
};

export type ChampionDamageBreakdown = {
  __typename?: "ChampionDamageBreakdown";
  damageMagic?: Maybe<Scalars["Int"]>;
  damagePhysical?: Maybe<Scalars["Int"]>;
  damageTrue?: Maybe<Scalars["Int"]>;
};

export type ChampionOtpStats = {
  __typename?: "ChampionOtpStats";
  championId?: Maybe<Scalars["Int"]>;
  gamesPlayed?: Maybe<Scalars["Int"]>;
  iconId?: Maybe<Scalars["Int"]>;
  lp?: Maybe<Scalars["Int"]>;
  rank?: Maybe<Scalars["String"]>;
  regionId?: Maybe<Scalars["String"]>;
  riotTagLine?: Maybe<Scalars["String"]>;
  riotUserName?: Maybe<Scalars["String"]>;
  tier?: Maybe<Scalars["String"]>;
  winRate?: Maybe<Scalars["Float"]>;
};

export type ChampionStat = {
  __typename?: "ChampionStat";
  championId?: Maybe<Scalars["Int"]>;
  damageDealtShared?: Maybe<Scalars["Float"]>;
  gamesPlayed?: Maybe<Scalars["Int"]>;
  lpGain?: Maybe<Scalars["Int"]>;
  queueType?: Maybe<Scalars["String"]>;
  totalCs?: Maybe<Scalars["Int"]>;
  totalDeaths?: Maybe<Scalars["Int"]>;
  totalKillsAndAssists?: Maybe<Scalars["Int"]>;
  winRate?: Maybe<Scalars["Float"]>;
};

export type ChampionStats = {
  __typename?: "ChampionStats";
  assists?: Maybe<Scalars["Int"]>;
  champId?: Maybe<Scalars["Int"]>;
  deaths?: Maybe<Scalars["Int"]>;
  games?: Maybe<Scalars["Int"]>;
  kills?: Maybe<Scalars["Int"]>;
  wins?: Maybe<Scalars["Int"]>;
};

export type ChampionTopPro = {
  __typename?: "ChampionTopPro";
  normalizedName: Scalars["String"];
  proInfo?: Maybe<ProInfo>;
  score: Scalars["Float"];
  totalGames: Scalars["Float"];
  totalWins: Scalars["Float"];
  winRate: Scalars["Float"];
};

export type ChargeLine = {
  __typename?: "ChargeLine";
  amount?: Maybe<Scalars["Int"]>;
  currency?: Maybe<Scalars["String"]>;
};

export type CoreBuild = {
  __typename?: "CoreBuild";
  items: Array<Maybe<Scalars["Int"]>>;
  matches: Scalars["Int"];
  wins: Scalars["Int"];
};

export type CreditCard = {
  __typename?: "CreditCard";
  addressCity?: Maybe<Scalars["String"]>;
  addressCountry?: Maybe<Scalars["String"]>;
  addressLineOne?: Maybe<Scalars["String"]>;
  addressLineTwo?: Maybe<Scalars["String"]>;
  addressState?: Maybe<Scalars["String"]>;
  addressZip: Scalars["String"];
  brand: Scalars["String"];
  expMonth: Scalars["Int"];
  expYear: Scalars["Int"];
  id?: Maybe<Scalars["String"]>;
  isDefault: Scalars["Boolean"];
  last4: Scalars["String"];
  name: Scalars["String"];
};

export type CustomizationData = {
  __typename?: "CustomizationData";
  headerBg?: Maybe<Scalars["String"]>;
  pinnedMatchData?: Maybe<MatchSummary>;
  pinnedMatchId?: Maybe<Scalars["String"]>;
  regionId?: Maybe<Scalars["String"]>;
  riotTagLine?: Maybe<Scalars["String"]>;
  riotUserName?: Maybe<Scalars["String"]>;
  twitchLink?: Maybe<Scalars["String"]>;
  twitchName?: Maybe<Scalars["String"]>;
  twitterLink?: Maybe<Scalars["String"]>;
  twitterName?: Maybe<Scalars["String"]>;
  youtubeLink?: Maybe<Scalars["String"]>;
  youtubeName?: Maybe<Scalars["String"]>;
};

export type EliteKills = {
  __typename?: "EliteKills";
  monsterType?: Maybe<Scalars["String"]>;
  timestamp?: Maybe<Scalars["Int"]>;
};

export type FeaturedGame = {
  __typename?: "FeaturedGame";
  bannedChampions?: Maybe<Array<Maybe<BannedChamp>>>;
  gameId: Scalars["Int"];
  gameLength?: Maybe<Scalars["Int"]>;
  gameMode: Scalars["Int"];
  gameQueueConfigId: Scalars["Int"];
  gameType?: Maybe<Scalars["String"]>;
  mapId?: Maybe<Scalars["Int"]>;
  participants?: Maybe<Array<Maybe<FeaturedParticipant>>>;
};

export type FeaturedGames = {
  __typename?: "FeaturedGames";
  gameList?: Maybe<Array<Maybe<FeaturedGame>>>;
};

export type FeaturedParticipant = {
  __typename?: "FeaturedParticipant";
  bot?: Maybe<Scalars["Boolean"]>;
  championId?: Maybe<Scalars["Int"]>;
  profileIconId?: Maybe<Scalars["Int"]>;
  rank?: Maybe<Scalars["String"]>;
  riotTagLine?: Maybe<Scalars["String"]>;
  riotUserName?: Maybe<Scalars["String"]>;
  spellOneId?: Maybe<Scalars["Int"]>;
  spellTwoId?: Maybe<Scalars["Int"]>;
  teamId?: Maybe<Scalars["Int"]>;
  tier?: Maybe<Scalars["String"]>;
};

export type FilterBuildsAndRunes = {
  __typename?: "FilterBuildsAndRunes";
  mmr?: Maybe<Scalars["String"]>;
  queueType?: Maybe<Scalars["String"]>;
  regionId?: Maybe<Scalars["String"]>;
};

export type FilterDefaults = {
  __typename?: "FilterDefaults";
  filterBuildsAndRunes?: Maybe<FilterBuildsAndRunes>;
  filterProBuilds?: Maybe<FilterProBuilds>;
  filterTierList?: Maybe<FilterTierList>;
};

export type FilterProBuilds = {
  __typename?: "FilterProBuilds";
  queueType?: Maybe<Scalars["String"]>;
  role?: Maybe<Scalars["String"]>;
  victoryOnly?: Maybe<Scalars["Boolean"]>;
};

export type FilterTierList = {
  __typename?: "FilterTierList";
  mmr?: Maybe<Scalars["String"]>;
  queueType?: Maybe<Scalars["String"]>;
  regionId?: Maybe<Scalars["String"]>;
  role?: Maybe<Scalars["String"]>;
  showAllChampions?: Maybe<Scalars["Boolean"]>;
};

export type FinishedItem = {
  __typename?: "FinishedItem";
  itemId?: Maybe<Scalars["Int"]>;
  timestamp?: Maybe<Scalars["Int"]>;
  type?: Maybe<Scalars["Int"]>;
};

export type HistoricPlayerRank = {
  __typename?: "HistoricPlayerRank";
  lp?: Maybe<Scalars["Int"]>;
  queueId?: Maybe<Scalars["Int"]>;
  rank?: Maybe<Scalars["String"]>;
  regionId?: Maybe<Scalars["String"]>;
  season?: Maybe<Scalars["Int"]>;
  tier?: Maybe<Scalars["String"]>;
};

export type HistoricalData = {
  __typename?: "HistoricalData";
  accountIdV3?: Maybe<Scalars["Int"]>;
  csDifferenceFrames?: Maybe<Array<Maybe<StatDifferenceFrame>>>;
  finishedItems?: Maybe<Array<Maybe<FinishedItem>>>;
  goldDifferenceFrames?: Maybe<Array<Maybe<StatDifferenceFrame>>>;
  itemPath?: Maybe<Array<Maybe<ItemPath>>>;
  kaDifferenceFrames?: Maybe<Array<Maybe<StatDifferenceFrame>>>;
  matchId?: Maybe<Scalars["String"]>;
  metricsData?: Maybe<Array<Maybe<MetricsData>>>;
  postGameData?: Maybe<Array<Maybe<PostGameData>>>;
  primaryStyle?: Maybe<Scalars["Int"]>;
  queueType?: Maybe<Scalars["String"]>;
  regionId?: Maybe<Scalars["String"]>;
  riotTagLine?: Maybe<Scalars["String"]>;
  riotUserName?: Maybe<Scalars["String"]>;
  runes?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  skillPath?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  statShards?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  subStyle?: Maybe<Scalars["Int"]>;
  teamOneOverview?: Maybe<TeamOverview>;
  teamTwoOverview?: Maybe<TeamOverview>;
  timelineData?: Maybe<Array<Maybe<TimelineData>>>;
  xpDifferenceFrames?: Maybe<Array<Maybe<StatDifferenceFrame>>>;
};

export type InputChampion = {
  championId: Scalars["Int"];
};

export type InputFilterBuildsAndRunes = {
  mmr: Scalars["String"];
  queueType: Scalars["String"];
  regionId: Scalars["String"];
};

export type InputFilterProBuilds = {
  queueType: Scalars["String"];
  role: Scalars["String"];
  victoryOnly: Scalars["Boolean"];
};

export type InputFilterTierList = {
  mmr: Scalars["String"];
  queueType: Scalars["String"];
  regionId: Scalars["String"];
  role: Scalars["String"];
  showAllChampions: Scalars["Boolean"];
};

export type InputSummoner = {
  iconId?: InputMaybe<Scalars["String"]>;
  iconUrl?: InputMaybe<Scalars["String"]>;
  isDefault?: InputMaybe<Scalars["Boolean"]>;
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
};

export type Invoice = {
  __typename?: "Invoice";
  brand?: Maybe<Scalars["String"]>;
  currency?: Maybe<Scalars["String"]>;
  last4?: Maybe<Scalars["String"]>;
  paid?: Maybe<Scalars["Boolean"]>;
  periodEnd?: Maybe<Scalars["UnixTimestampSec"]>;
  periodStart?: Maybe<Scalars["UnixTimestampSec"]>;
  totalPaid?: Maybe<Scalars["Int"]>;
};

export type Item = {
  __typename?: "Item";
  matches: Scalars["Int"];
  wins: Scalars["Int"];
};

export type ItemPath = {
  __typename?: "ItemPath";
  itemId?: Maybe<Scalars["Int"]>;
  timestamp?: Maybe<Scalars["Int"]>;
  type?: Maybe<Scalars["Int"]>;
};

/** A build, all data needed for the recommended builds page. */
export type ItemRecommendations = {
  __typename?: "ItemRecommendations";
  itemSlotNumber: Scalars["Int"];
  items: Array<Maybe<Item>>;
};

export type LastTenWinrate = {
  __typename?: "LastTenWinrate";
  gameList?: Maybe<Scalars["String"]>;
  totalGames?: Maybe<Scalars["Int"]>;
};

export type LgChampStats = {
  __typename?: "LgChampStats";
  assists?: Maybe<Scalars["Int"]>;
  deaths?: Maybe<Scalars["Int"]>;
  kills?: Maybe<Scalars["Int"]>;
};

export type LiveGame = {
  __typename?: "LiveGame";
  gameLengthSeconds: Scalars["Int"];
  gameType?: Maybe<Scalars["String"]>;
  queueId?: Maybe<Scalars["Int"]>;
  teamA?: Maybe<Array<Maybe<Participant>>>;
  teamB?: Maybe<Array<Maybe<Participant>>>;
};

export type LiveGameSummoner = {
  championId: Scalars["Int"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
};

export type LiveGameTags = {
  __typename?: "LiveGameTags";
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
  tagList?: Maybe<Array<Maybe<Tag>>>;
};

export type LoginState = {
  __typename?: "LoginState";
  token: Scalars["String"];
};

export type LolSettings = {
  __typename?: "LolSettings";
  favoriteChampions?: Maybe<Array<Maybe<Champion>>>;
  favoriteSummoners?: Maybe<Array<Maybe<Summoner>>>;
  summoners?: Maybe<Array<Maybe<Summoner>>>;
};

export type LpInfo = {
  __typename?: "LpInfo";
  lp?: Maybe<Scalars["Int"]>;
  placement?: Maybe<Scalars["Int"]>;
  promoProgress?: Maybe<Scalars["String"]>;
  promoTarget?: Maybe<Scalars["String"]>;
  promotedTo?: Maybe<PromotedRank>;
};

export type LpStat = {
  __typename?: "LpStat";
  lpTrack?: Maybe<Array<Maybe<LpStatus>>>;
  roleLp?: Maybe<RoleRates>;
};

export type LpStatus = {
  __typename?: "LpStatus";
  assists?: Maybe<Scalars["Int"]>;
  championId?: Maybe<Scalars["Int"]>;
  deaths?: Maybe<Scalars["Int"]>;
  kills?: Maybe<Scalars["Int"]>;
  lp?: Maybe<Scalars["Int"]>;
  matchCreationTime?: Maybe<Scalars["String"]>;
  matchId?: Maybe<Scalars["Int"]>;
  rank?: Maybe<Scalars["String"]>;
  score?: Maybe<Scalars["Int"]>;
  tier?: Maybe<Scalars["String"]>;
  version?: Maybe<Scalars["String"]>;
};

export type Match = {
  __typename?: "Match";
  allPlayerRanks?: Maybe<Array<Maybe<AllPlayerRank>>>;
  historicalData: HistoricalData;
  matchSummary?: Maybe<MatchSummary>;
  performanceScore?: Maybe<Array<Maybe<PerformanceScore>>>;
  playerInfo?: Maybe<PlayerInfo>;
  playerRank?: Maybe<PlayerRank>;
  playerStatistics?: Maybe<PlayerStatistics>;
  winningTeam?: Maybe<Scalars["Int"]>;
};

export type MatchSummary = {
  __typename?: "MatchSummary";
  assists?: Maybe<Scalars["Int"]>;
  augments?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  championId?: Maybe<Scalars["Int"]>;
  cs?: Maybe<Scalars["Int"]>;
  damage?: Maybe<Scalars["Int"]>;
  deaths?: Maybe<Scalars["Int"]>;
  gold?: Maybe<Scalars["Int"]>;
  items?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  jungleCs?: Maybe<Scalars["Int"]>;
  killParticipation?: Maybe<Scalars["Int"]>;
  kills?: Maybe<Scalars["Int"]>;
  level?: Maybe<Scalars["Int"]>;
  lpInfo?: Maybe<LpInfo>;
  matchCreationTime?: Maybe<Scalars["UnixTimestamp"]>;
  matchDuration?: Maybe<Scalars["Int"]>;
  matchId?: Maybe<Scalars["Int"]>;
  maximumKillStreak?: Maybe<Scalars["Int"]>;
  perfScoresA?: Maybe<Array<Maybe<PerfScore>>>;
  perfScoresB?: Maybe<Array<Maybe<PerfScore>>>;
  primaryStyle?: Maybe<Scalars["Int"]>;
  psHardCarry?: Maybe<Scalars["Int"]>;
  psTeamPlay?: Maybe<Scalars["Int"]>;
  queueType?: Maybe<Scalars["String"]>;
  regionId?: Maybe<Scalars["String"]>;
  riotTagLine?: Maybe<Scalars["String"]>;
  riotUserName?: Maybe<Scalars["String"]>;
  role?: Maybe<Scalars["Int"]>;
  roleBoundItem?: Maybe<Scalars["Int"]>;
  roleQuestCompletion?: Maybe<Scalars["Int"]>;
  runes?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  subStyle?: Maybe<Scalars["Int"]>;
  summonerName?: Maybe<Scalars["String"]>;
  summonerSpells?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  teamA?: Maybe<Array<Maybe<TeamData>>>;
  teamB?: Maybe<Array<Maybe<TeamData>>>;
  version?: Maybe<Scalars["String"]>;
  visionScore?: Maybe<Scalars["Int"]>;
  win?: Maybe<Scalars["Boolean"]>;
};

export type MatchupStatistics = {
  __typename?: "MatchupStatistics";
  championId?: Maybe<Scalars["Int"]>;
  opponentChampionId?: Maybe<Scalars["Int"]>;
  role?: Maybe<Scalars["Int"]>;
  totalGames?: Maybe<Scalars["Int"]>;
  winSum?: Maybe<Scalars["Int"]>;
};

export type MetricsData = {
  __typename?: "MetricsData";
  cs?: Maybe<Scalars["Int"]>;
  jungleCs?: Maybe<Scalars["Int"]>;
  level?: Maybe<Scalars["Int"]>;
  pid?: Maybe<Scalars["Int"]>;
  position?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  riotTagLine?: Maybe<Scalars["String"]>;
  riotUserName?: Maybe<Scalars["String"]>;
  timestamp?: Maybe<Scalars["Int"]>;
  totalDamageDoneToChampions?: Maybe<Scalars["Int"]>;
  totalDamageTaken?: Maybe<Scalars["Int"]>;
  totalGold?: Maybe<Scalars["Int"]>;
  xp?: Maybe<Scalars["Int"]>;
};

export type MinuteByMinuteData = {
  __typename?: "MinuteByMinuteData";
  assistsMinuteData?: Maybe<Array<Maybe<Scalars["Float"]>>>;
  csMinuteData?: Maybe<Array<Maybe<Scalars["Float"]>>>;
  deathsMinuteData?: Maybe<Array<Maybe<Scalars["Float"]>>>;
  goldMinuteData?: Maybe<Array<Maybe<Scalars["Float"]>>>;
  isRoleOnly?: Maybe<Scalars["Boolean"]>;
  killsMinuteData?: Maybe<Array<Maybe<Scalars["Float"]>>>;
  kpMinuteData?: Maybe<Array<Maybe<Scalars["Float"]>>>;
  wardsMinuteData?: Maybe<Array<Maybe<Scalars["Float"]>>>;
  xpMinuteData?: Maybe<Array<Maybe<Scalars["Float"]>>>;
};

export type Multisearch = {
  __typename?: "Multisearch";
  bestChamps?: Maybe<Array<Maybe<ChampionStats>>>;
  rankData?: Maybe<RankScore>;
  riotTagLine?: Maybe<Scalars["String"]>;
  riotUserName?: Maybe<Scalars["String"]>;
  roleStats?: Maybe<Array<Maybe<MultisearchRoleStats>>>;
  totalGamesLastFifteen?: Maybe<Scalars["Int"]>;
  winperc?: Maybe<Scalars["Float"]>;
  winsLastFifteen?: Maybe<Scalars["Int"]>;
  winstreak?: Maybe<Scalars["Int"]>;
  worstChamps?: Maybe<Array<Maybe<ChampionStats>>>;
};

export type MultisearchRoleStats = {
  __typename?: "MultisearchRoleStats";
  games?: Maybe<Scalars["Int"]>;
  roleName?: Maybe<Scalars["String"]>;
  wins?: Maybe<Scalars["Int"]>;
};

export type OauthConnection = {
  __typename?: "OauthConnection";
  connectionUuid: Scalars["String"];
  creationTime?: Maybe<Scalars["UnixTimestampSec"]>;
  lastRefreshTime?: Maybe<Scalars["UnixTimestampSec"]>;
  metadata?: Maybe<Scalars["JSON"]>;
  providerEmail?: Maybe<Scalars["String"]>;
  providerName: Scalars["String"];
  providerUserId: Scalars["String"];
  providerUsername?: Maybe<Scalars["String"]>;
};

export type OverallChampionStats = {
  __typename?: "OverallChampionStats";
  damageShare?: Maybe<Scalars["Float"]>;
  efficiency?: Maybe<Scalars["Float"]>;
  finalLvlDiff?: Maybe<Scalars["Float"]>;
  goldShare?: Maybe<Scalars["Float"]>;
  killParticipation?: Maybe<Scalars["Float"]>;
  visionScore?: Maybe<Scalars["Float"]>;
};

export type Participant = {
  __typename?: "Participant";
  arenaPlacements: ArenaPlacements;
  banId: Scalars["Int"];
  championId: Scalars["Int"];
  championLosses: Scalars["Int"];
  championStats?: Maybe<LgChampStats>;
  championWins: Scalars["Int"];
  currentRole: Scalars["Int"];
  currentSeasonRankScore?: Maybe<RankScore>;
  isAnonEnabled: Scalars["Boolean"];
  onRole: Scalars["Boolean"];
  partyNumber?: Maybe<Scalars["Int"]>;
  previousSeasonRankScore?: Maybe<RankScore>;
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
  roleDatas?: Maybe<Array<Maybe<RoleData>>>;
  summonerIconId: Scalars["Int"];
  summonerRuneA?: Maybe<Scalars["Int"]>;
  summonerRuneB?: Maybe<Scalars["Int"]>;
  summonerRuneData?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  summonerSpellA: Scalars["Int"];
  summonerSpellB: Scalars["Int"];
  threatLevel: Scalars["Int"];
};

export type PatchInReviewStats = {
  __typename?: "PatchInReviewStats";
  summonerChampionStats?: Maybe<SummonerChampionStats>;
  summonerLpStats?: Maybe<SummonerLpStats>;
  summonerOpponentChampionStats?: Maybe<Array<Maybe<SummonerOpponentChampionStat>>>;
  summonerOverallStats?: Maybe<SummonerOverallStats>;
  summonerSeasonOverallStats?: Maybe<SummonerSeasonOverallStats>;
  summonerTeamShareStats?: Maybe<SummonerTeamShareStats>;
  summonerWinPlayRates?: Maybe<Array<Maybe<SummonerWinPlayRates>>>;
};

export type PaymentSubscription = {
  __typename?: "PaymentSubscription";
  cancelAtPeriodEnd?: Maybe<Scalars["Boolean"]>;
  currentPeriodEnd?: Maybe<Scalars["UnixTimestampSec"]>;
  isBraintree?: Maybe<Scalars["Boolean"]>;
  isPaypal?: Maybe<Scalars["Boolean"]>;
  status?: Maybe<Scalars["String"]>;
};

export type Paypal = {
  __typename?: "Paypal";
  email: Scalars["String"];
  id?: Maybe<Scalars["String"]>;
};

export type PerfScore = {
  __typename?: "PerfScore";
  hardCarry?: Maybe<Scalars["Int"]>;
  riotTagLine?: Maybe<Scalars["String"]>;
  riotUserName?: Maybe<Scalars["String"]>;
  summonerName?: Maybe<Scalars["String"]>;
  teamplay?: Maybe<Scalars["Int"]>;
};

export type PerformanceScore = {
  __typename?: "PerformanceScore";
  damageShare?: Maybe<Scalars["Float"]>;
  damageShareAgg?: Maybe<Scalars["Float"]>;
  damageShareTotal?: Maybe<Scalars["Float"]>;
  finalLvlDiff?: Maybe<Scalars["Int"]>;
  finalLvlDiffAgg?: Maybe<Scalars["Float"]>;
  finalLvlDiffTotal?: Maybe<Scalars["Float"]>;
  goldShare?: Maybe<Scalars["Float"]>;
  goldShareAgg?: Maybe<Scalars["Float"]>;
  goldShareTotal?: Maybe<Scalars["Float"]>;
  hardCarry?: Maybe<Scalars["Float"]>;
  killParticipation?: Maybe<Scalars["Float"]>;
  killParticipationAgg?: Maybe<Scalars["Float"]>;
  killParticipationTotal?: Maybe<Scalars["Float"]>;
  kpOverGs?: Maybe<Scalars["Float"]>;
  kpOverGsAgg?: Maybe<Scalars["Float"]>;
  kpOverGsTotal?: Maybe<Scalars["Float"]>;
  riotTagLine?: Maybe<Scalars["String"]>;
  riotUserName?: Maybe<Scalars["String"]>;
  teamplay?: Maybe<Scalars["Float"]>;
  visionScore?: Maybe<Scalars["Float"]>;
  visionScoreAgg?: Maybe<Scalars["Float"]>;
  visionScoreTotal?: Maybe<Scalars["Float"]>;
};

export type PlanChangePreview = {
  __typename?: "PlanChangePreview";
  chargeAmount?: Maybe<Scalars["Int"]>;
  chargeLines?: Maybe<Array<Maybe<ChargeLine>>>;
  planCost?: Maybe<Scalars["Int"]>;
};

export type PlayedWith = {
  __typename?: "PlayedWith";
  riotIds?: Maybe<Array<Maybe<RiotIdOutput>>>;
};

export type PlayerChampionMaxAverageStats = {
  __typename?: "PlayerChampionMaxAverageStats";
  averageDamageShare?: Maybe<Scalars["Float"]>;
  averageEfficiency?: Maybe<Scalars["Float"]>;
  averageGoldShare?: Maybe<Scalars["Float"]>;
  averageHardcarry?: Maybe<Scalars["Float"]>;
  averageKillParticipation?: Maybe<Scalars["Float"]>;
  averageLevelDifference?: Maybe<Scalars["Float"]>;
  averagePsDamageShare?: Maybe<Scalars["Float"]>;
  averagePsEfficiency?: Maybe<Scalars["Float"]>;
  averagePsGoldShare?: Maybe<Scalars["Float"]>;
  averagePsKillParticipation?: Maybe<Scalars["Float"]>;
  averagePsLevelDifference?: Maybe<Scalars["Float"]>;
  averagePsVisionScore?: Maybe<Scalars["Float"]>;
  averageTeamplay?: Maybe<Scalars["Float"]>;
  averageVisionScore?: Maybe<Scalars["Float"]>;
  maxPsDamageShare?: Maybe<Scalars["Int"]>;
  maxPsEfficiency?: Maybe<Scalars["Int"]>;
  maxPsGoldShare?: Maybe<Scalars["Int"]>;
  maxPsKillParticipation?: Maybe<Scalars["Int"]>;
  maxPsLevelDifference?: Maybe<Scalars["Int"]>;
  maxPsVisionScore?: Maybe<Scalars["Int"]>;
};

export type PlayerChampionStats = {
  __typename?: "PlayerChampionStats";
  averageAssists?: Maybe<Scalars["Float"]>;
  averageCs?: Maybe<Scalars["Float"]>;
  averageDamage?: Maybe<Scalars["Float"]>;
  averageDeaths?: Maybe<Scalars["Float"]>;
  averageGold?: Maybe<Scalars["Float"]>;
  averageKills?: Maybe<Scalars["Float"]>;
  csLeadAtFifteen?: Maybe<Scalars["Float"]>;
  gamesPlayed?: Maybe<Scalars["Int"]>;
  goldLeadAtFifteen?: Maybe<Scalars["Float"]>;
  killLeadAtFifteen?: Maybe<Scalars["Float"]>;
  losses?: Maybe<Scalars["Int"]>;
  maxDeaths?: Maybe<Scalars["Int"]>;
  maxKills?: Maybe<Scalars["Int"]>;
  totalDoubleKills?: Maybe<Scalars["Int"]>;
  totalPentaKills?: Maybe<Scalars["Int"]>;
  totalQuadraKills?: Maybe<Scalars["Int"]>;
  totalTripleKills?: Maybe<Scalars["Int"]>;
  winRate?: Maybe<Scalars["Float"]>;
  wins?: Maybe<Scalars["Int"]>;
  xpLeadAtFifteen?: Maybe<Scalars["Float"]>;
};

export type PlayerInfo = {
  __typename?: "PlayerInfo";
  accountIdV3?: Maybe<Scalars["Int"]>;
  accountIdV4?: Maybe<Scalars["String"]>;
  exodiaUuid?: Maybe<Scalars["String"]>;
  iconId?: Maybe<Scalars["Int"]>;
  puuidV4?: Maybe<Scalars["String"]>;
  regionId?: Maybe<Scalars["String"]>;
  riotTagLine?: Maybe<Scalars["String"]>;
  riotUserName?: Maybe<Scalars["String"]>;
  summonerIdV3?: Maybe<Scalars["Int"]>;
  summonerIdV4?: Maybe<Scalars["String"]>;
  summonerLevel?: Maybe<Scalars["Int"]>;
};

export type PlayerMatchLeadTimelineAveragesStats = {
  __typename?: "PlayerMatchLeadTimelineAveragesStats";
  csLeadAvgList?: Maybe<Array<Maybe<Scalars["Float"]>>>;
  goldLeadAvgList?: Maybe<Array<Maybe<Scalars["Float"]>>>;
  xpLeadAvgList?: Maybe<Array<Maybe<Scalars["Float"]>>>;
};

export type PlayerMatchSummaries = {
  __typename?: "PlayerMatchSummaries";
  finishedMatchSummaries?: Maybe<Scalars["Boolean"]>;
  matchSummaries?: Maybe<Array<Maybe<MatchSummary>>>;
  totalNumMatches?: Maybe<Scalars["Int"]>;
};

export type PlayerMatchTimelineAveragesStats = {
  __typename?: "PlayerMatchTimelineAveragesStats";
  csAvgList?: Maybe<Array<Maybe<Scalars["Float"]>>>;
  goldAvgList?: Maybe<Array<Maybe<Scalars["Float"]>>>;
  xpAvgList?: Maybe<Array<Maybe<Scalars["Float"]>>>;
};

export type PlayerOverviewKpis = {
  __typename?: "PlayerOverviewKpis";
  gameStreak?: Maybe<Scalars["Int"]>;
  maxKills?: Maybe<Scalars["Int"]>;
  totalAssists?: Maybe<Scalars["Int"]>;
  totalCs?: Maybe<Scalars["Int"]>;
  totalDeaths?: Maybe<Scalars["Int"]>;
  totalGames?: Maybe<Scalars["Int"]>;
  totalKills?: Maybe<Scalars["Int"]>;
  totalSeconds?: Maybe<Scalars["Int"]>;
  totalWins?: Maybe<Scalars["Int"]>;
};

export type PlayerRank = {
  __typename?: "PlayerRank";
  exodiaUuid?: Maybe<Scalars["String"]>;
  rankScores?: Maybe<Array<Maybe<RankScore>>>;
};

export type PlayerStatistics = {
  __typename?: "PlayerStatistics";
  basicChampionPerformances?: Maybe<Array<Maybe<BasicChampionPerformance>>>;
  exodiaUuid?: Maybe<Scalars["String"]>;
  puuid?: Maybe<Scalars["String"]>;
  queueType?: Maybe<Scalars["Int"]>;
  regionId?: Maybe<Scalars["String"]>;
  role?: Maybe<Scalars["Int"]>;
  seasonId?: Maybe<Scalars["Int"]>;
};

export type PopularProInfo = {
  __typename?: "PopularProInfo";
  bestChampions?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  mainRole: Scalars["String"];
  normalizedName: Scalars["String"];
  proInfo?: Maybe<ProInfo>;
};

export type PostGameData = {
  __typename?: "PostGameData";
  assists?: Maybe<Scalars["Int"]>;
  augments?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  carryPercentage?: Maybe<Scalars["Int"]>;
  championId?: Maybe<Scalars["Int"]>;
  cs?: Maybe<Scalars["Int"]>;
  damage?: Maybe<Scalars["Int"]>;
  damageTaken?: Maybe<Scalars["Int"]>;
  deaths?: Maybe<Scalars["Int"]>;
  eliteKills?: Maybe<Array<Maybe<EliteKills>>>;
  gold?: Maybe<Scalars["Int"]>;
  items?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  jungleCs?: Maybe<Scalars["Int"]>;
  keystone?: Maybe<Scalars["Int"]>;
  kills?: Maybe<Scalars["Int"]>;
  level?: Maybe<Scalars["Int"]>;
  placement?: Maybe<Scalars["Int"]>;
  playerSubteamId?: Maybe<Scalars["Int"]>;
  riotTagLine?: Maybe<Scalars["String"]>;
  riotUserName?: Maybe<Scalars["String"]>;
  role?: Maybe<Scalars["Int"]>;
  roleBoundItem?: Maybe<Scalars["Int"]>;
  subStyle?: Maybe<Scalars["Int"]>;
  summonerName?: Maybe<Scalars["String"]>;
  summonerSpells?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  teamId?: Maybe<Scalars["Int"]>;
  visionScore?: Maybe<Scalars["Int"]>;
  wardsPlaced?: Maybe<Scalars["Int"]>;
};

export type PremadeData = {
  __typename?: "PremadeData";
  numGames?: Maybe<Scalars["Int"]>;
  premade?: Maybe<Array<Maybe<Scalars["String"]>>>;
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
};

export type Premium = {
  __typename?: "Premium";
  freeTrialAvailable?: Maybe<Scalars["Boolean"]>;
  hasFailedPayment?: Maybe<Scalars["Boolean"]>;
  hasLegacyBoost?: Maybe<Scalars["Boolean"]>;
  isOnFreeTrial?: Maybe<Scalars["Boolean"]>;
  isPremium: Scalars["Boolean"];
  paymentFailureDate?: Maybe<Scalars["UnixTimestampSec"]>;
  premiumVersion?: Maybe<Scalars["String"]>;
};

export type PremiumPlanPrices = {
  __typename?: "PremiumPlanPrices";
  amount?: Maybe<Scalars["Float"]>;
  boostDiscountAmount?: Maybe<Scalars["Float"]>;
  boostDiscountPercent?: Maybe<Scalars["Int"]>;
  currency?: Maybe<Scalars["String"]>;
  hasBoostDiscount?: Maybe<Scalars["Boolean"]>;
  hasFreeTrial?: Maybe<Scalars["Boolean"]>;
  originalPrice?: Maybe<Scalars["Float"]>;
  planDuration?: Maybe<Scalars["Int"]>;
  planId?: Maybe<Scalars["String"]>;
  recurringPrice?: Maybe<Scalars["Float"]>;
  trialLength?: Maybe<Scalars["Int"]>;
  trialUnit?: Maybe<Scalars["String"]>;
};

export type ProChampionMatchPage = {
  __typename?: "ProChampionMatchPage";
  matchList?: Maybe<Array<Maybe<ProMatchSummary>>>;
  mostPopularBoots?: Maybe<Array<Maybe<ProPopularItems>>>;
  mostPopularItems?: Maybe<Array<Maybe<ProPopularItems>>>;
};

export type ProChampionPick = {
  __typename?: "ProChampionPick";
  championId: Scalars["Int"];
  pickRate: Scalars["Float"];
  role: Scalars["String"];
  winRate: Scalars["Float"];
};

export type ProChampionRolePercentages = {
  __typename?: "ProChampionRolePercentages";
  adc: Scalars["Float"];
  jungle: Scalars["Float"];
  mid: Scalars["Float"];
  supp: Scalars["Float"];
  top: Scalars["Float"];
};

export type ProChampionRunePercentage = {
  __typename?: "ProChampionRunePercentage";
  count: Scalars["Int"];
  percentage: Scalars["Float"];
  perk0: Scalars["Int"];
  subStyle: Scalars["Int"];
};

export type ProChampionSkillPriority = {
  __typename?: "ProChampionSkillPriority";
  skillPriority: Array<Maybe<Scalars["String"]>>;
};

export type ProChampionSpellPercentage = {
  __typename?: "ProChampionSpellPercentage";
  percentage: Scalars["Float"];
  spell: Scalars["Int"];
};

export type ProChampionWinRate = {
  __typename?: "ProChampionWinRate";
  matches: Scalars["Int"];
  percentage: Scalars["Float"];
};

export type ProInfo = {
  __typename?: "ProInfo";
  currentTeam: Scalars["String"];
  league?: Maybe<Scalars["String"]>;
  mainRole?: Maybe<Scalars["String"]>;
  officialName: Scalars["String"];
  region?: Maybe<Scalars["String"]>;
  tags?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type ProMatch = {
  __typename?: "ProMatch";
  teams?: Maybe<Array<Maybe<ProMatchTeam>>>;
};

export type ProMatchItemEvent = {
  __typename?: "ProMatchItemEvent";
  itemId: Scalars["Int"];
  timestamp: Scalars["Int"];
  type: Scalars["Int"];
};

export type ProMatchParticipant = {
  __typename?: "ProMatchParticipant";
  assists?: Maybe<Scalars["Int"]>;
  calculatedRole?: Maybe<Scalars["String"]>;
  championId?: Maybe<Scalars["Int"]>;
  cs?: Maybe<Scalars["Int"]>;
  damage?: Maybe<Scalars["Int"]>;
  deaths?: Maybe<Scalars["Int"]>;
  finalBuild?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  jungleCs?: Maybe<Scalars["Int"]>;
  kills?: Maybe<Scalars["Int"]>;
  officialName?: Maybe<Scalars["String"]>;
  rank?: Maybe<RankScore>;
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
  roleBoundItem?: Maybe<Scalars["Int"]>;
  runes: ProMatchRunes;
  statShards?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  summonerSpells?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  wardsPlaced?: Maybe<Scalars["Int"]>;
};

export type ProMatchRunes = {
  __typename?: "ProMatchRunes";
  perk0: Scalars["Int"];
  perk1: Scalars["Int"];
  perk2: Scalars["Int"];
  perk3: Scalars["Int"];
  perk4: Scalars["Int"];
  perk5: Scalars["Int"];
  primaryStyle: Scalars["Int"];
  subStyle: Scalars["Int"];
};

export type ProMatchSummary = {
  __typename?: "ProMatchSummary";
  calculatedRole: Scalars["String"];
  championId: Scalars["Int"];
  completedItems?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  cs: Scalars["Int"];
  currentTeam?: Maybe<Scalars["String"]>;
  finalBuild?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  gold: Scalars["Int"];
  isOtp?: Maybe<Scalars["String"]>;
  isWorlds?: Maybe<Scalars["String"]>;
  itemPath?: Maybe<Array<Maybe<ProMatchItemEvent>>>;
  jungleCs: Scalars["Int"];
  killParticipation: Scalars["Float"];
  matchDuration: Scalars["Int"];
  matchId: Scalars["Int"];
  matchTimestamp: Scalars["Int"];
  normalizedName?: Maybe<Scalars["String"]>;
  opponentChampionId: Scalars["Int"];
  proInfo?: Maybe<ProInfo>;
  proLeague?: Maybe<Scalars["String"]>;
  regionId: Scalars["String"];
  riotTagLine?: Maybe<Scalars["String"]>;
  riotUserName?: Maybe<Scalars["String"]>;
  roleBoundItem?: Maybe<Scalars["Int"]>;
  runes: ProMatchRunes;
  seasonId: Scalars["Int"];
  skillEvolveOrders?: Maybe<Scalars["String"]>;
  skillOrders: Scalars["String"];
  statShards?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  summonerSpells?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  teamId: Scalars["Int"];
  totalAssists: Scalars["Int"];
  totalDeaths: Scalars["Int"];
  totalKills: Scalars["Int"];
  version: Scalars["String"];
  win: Scalars["Boolean"];
};

export type ProMatchTeam = {
  __typename?: "ProMatchTeam";
  participants?: Maybe<Array<Maybe<ProMatchParticipant>>>;
  teamId: Scalars["Int"];
  win: Scalars["Boolean"];
};

export type ProPopularItems = {
  __typename?: "ProPopularItems";
  itemId?: Maybe<Scalars["Int"]>;
  pickRate?: Maybe<Scalars["Float"]>;
};

export type ProStatsRanking = {
  __typename?: "ProStatsRanking";
  csPerMinRanking: Scalars["Int"];
  goldPerMinRanking: Scalars["Int"];
  jungleCsPerMinRanking: Scalars["Int"];
  kdaRanking: Scalars["Int"];
  killParticipationRanking: Scalars["Int"];
};

export type ProfileChampRanking = {
  __typename?: "ProfileChampRanking";
  assists?: Maybe<Scalars["Int"]>;
  champId?: Maybe<Scalars["Int"]>;
  deaths?: Maybe<Scalars["Int"]>;
  games?: Maybe<Scalars["Int"]>;
  kills?: Maybe<Scalars["Int"]>;
  wins?: Maybe<Scalars["Int"]>;
};

export type ProfileChampRankingsContainer = {
  __typename?: "ProfileChampRankingsContainer";
  bestChamps?: Maybe<Array<Maybe<ProfileChampRanking>>>;
  worstChamps?: Maybe<Array<Maybe<ProfileChampRanking>>>;
};

export type ProfileInit = {
  __typename?: "ProfileInit";
  customizationData?: Maybe<CustomizationData>;
  finishedMatchHistory?: Maybe<Scalars["Boolean"]>;
  lastModified?: Maybe<Scalars["Int"]>;
  matchHistory?: Maybe<Array<Maybe<MatchSummary>>>;
  memberStatus?: Maybe<Scalars["String"]>;
  playerInfo?: Maybe<PlayerInfo>;
  playerOverviewKpis?: Maybe<PlayerOverviewKpis>;
  playerRank?: Maybe<PlayerRank>;
  playerStatistics?: Maybe<PlayerStatistics>;
  premium?: Maybe<Scalars["Boolean"]>;
  sessionUuid?: Maybe<Scalars["String"]>;
  totalNumMatches?: Maybe<Scalars["Int"]>;
};

export type ProfileInitSimple = {
  __typename?: "ProfileInitSimple";
  customizationData?: Maybe<CustomizationData>;
  lastModified?: Maybe<Scalars["Int"]>;
  memberStatus?: Maybe<Scalars["String"]>;
  playerInfo?: Maybe<PlayerInfo>;
  premium?: Maybe<Scalars["Boolean"]>;
};

export type ProfileRank = {
  __typename?: "ProfileRank";
  playerInfo?: Maybe<PlayerInfo>;
  soloQueueRank?: Maybe<RankScore>;
};

export type ProfileSuggestion = {
  __typename?: "ProfileSuggestion";
  iconId?: Maybe<Scalars["Int"]>;
  lp?: Maybe<Scalars["Int"]>;
  puuid?: Maybe<Scalars["String"]>;
  rank?: Maybe<Scalars["String"]>;
  rankScore?: Maybe<Scalars["Int"]>;
  regionId?: Maybe<Scalars["String"]>;
  riotId?: Maybe<Scalars["String"]>;
  riotTagLine?: Maybe<Scalars["String"]>;
  riotUserName?: Maybe<Scalars["String"]>;
  summonerLevel?: Maybe<Scalars["Int"]>;
  tier?: Maybe<Scalars["String"]>;
};

export type PromotedRank = {
  __typename?: "PromotedRank";
  rank?: Maybe<Scalars["String"]>;
  tier?: Maybe<Scalars["String"]>;
};

export type RankScore = {
  __typename?: "RankScore";
  lastUpdatedAt?: Maybe<Scalars["Int"]>;
  losses?: Maybe<Scalars["Int"]>;
  lp?: Maybe<Scalars["Int"]>;
  promoProgress?: Maybe<Scalars["String"]>;
  queueType?: Maybe<Scalars["String"]>;
  rank?: Maybe<Scalars["String"]>;
  role?: Maybe<Scalars["String"]>;
  seasonId?: Maybe<Scalars["Int"]>;
  tier?: Maybe<Scalars["String"]>;
  wins?: Maybe<Scalars["Int"]>;
};

export type RankSnapshot = {
  __typename?: "RankSnapshot";
  insertedAt?: Maybe<Scalars["UnixTimestamp"]>;
  losses?: Maybe<Scalars["Int"]>;
  lp?: Maybe<Scalars["Int"]>;
  promoProgress?: Maybe<Scalars["String"]>;
  queueId?: Maybe<Scalars["Int"]>;
  rank?: Maybe<Scalars["String"]>;
  tier?: Maybe<Scalars["String"]>;
  wins?: Maybe<Scalars["Int"]>;
};

export type RankedLeaderboardPage = {
  __typename?: "RankedLeaderboardPage";
  players?: Maybe<Array<Maybe<RankedLeaderboardPlayer>>>;
  topPlayerMostPlayedChamp?: Maybe<Scalars["Int"]>;
  totalPlayerCount?: Maybe<Scalars["Int"]>;
};

export type RankedLeaderboardPlayer = {
  __typename?: "RankedLeaderboardPlayer";
  iconId?: Maybe<Scalars["Int"]>;
  losses?: Maybe<Scalars["Int"]>;
  lp?: Maybe<Scalars["Int"]>;
  overallRanking?: Maybe<Scalars["Int"]>;
  rank?: Maybe<Scalars["String"]>;
  riotTagLine?: Maybe<Scalars["String"]>;
  riotUserName?: Maybe<Scalars["String"]>;
  summonerLevel?: Maybe<Scalars["Int"]>;
  tier?: Maybe<Scalars["String"]>;
  wins?: Maybe<Scalars["Int"]>;
};

export type RecentRoleRates = {
  __typename?: "RecentRoleRates";
  adc?: Maybe<RecentRoleStat>;
  jungle?: Maybe<RecentRoleStat>;
  mid?: Maybe<RecentRoleStat>;
  none?: Maybe<RecentRoleStat>;
  supp?: Maybe<RecentRoleStat>;
  top?: Maybe<RecentRoleStat>;
};

export type RecentRoleStat = {
  __typename?: "RecentRoleStat";
  gameCount?: Maybe<Scalars["Int"]>;
  winCount?: Maybe<Scalars["Int"]>;
};

/** All data needed for the overview page. (e.g. https://u.gg/lol/champions/riven/build) */
export type Recommendation = {
  __typename?: "Recommendation";
  championId?: Maybe<Scalars["Int"]>;
  coreBuild?: Maybe<CoreBuild>;
  itemRecommendations?: Maybe<Array<Maybe<ItemRecommendations>>>;
  lastUpdatedAt?: Maybe<Scalars["Int"]>;
  mmr?: Maybe<Scalars["String"]>;
  opponentChampionId?: Maybe<Scalars["Int"]>;
  queueType?: Maybe<Scalars["String"]>;
  regionId?: Maybe<Scalars["String"]>;
  role?: Maybe<Scalars["String"]>;
  runes?: Maybe<Runes>;
  skillOrder?: Maybe<SkillOrder>;
  startingBuild?: Maybe<StartingBuild>;
  summonerSpells?: Maybe<SummonerSpells>;
  version?: Maybe<Scalars["String"]>;
  winsLosses?: Maybe<WinsLosses>;
};

export type RecurlyBillingData = {
  __typename?: "RecurlyBillingData";
  invoices?: Maybe<Array<Maybe<RecurlyInvoice>>>;
  paymentMethods?: Maybe<Array<Maybe<RecurlyPaymentMethodDetail>>>;
  subscription?: Maybe<RecurlySubscription>;
  upcomingInvoice?: Maybe<RecurlyUpcomingInvoice>;
};

export type RecurlyInvoice = {
  __typename?: "RecurlyInvoice";
  brand?: Maybe<Scalars["String"]>;
  currency?: Maybe<Scalars["String"]>;
  last4?: Maybe<Scalars["String"]>;
  paid?: Maybe<Scalars["Boolean"]>;
  periodEnd?: Maybe<Scalars["UnixTimestampSec"]>;
  periodStart?: Maybe<Scalars["UnixTimestampSec"]>;
  totalPaid?: Maybe<Scalars["Int"]>;
};

export type RecurlyPaymentMethod = {
  __typename?: "RecurlyPaymentMethod";
  cardType?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
  isDefault?: Maybe<Scalars["Boolean"]>;
  lastFour?: Maybe<Scalars["String"]>;
  paypalEmail?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
};

export type RecurlyPaymentMethodDetail = {
  __typename?: "RecurlyPaymentMethodDetail";
  cardType?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
  isDefault?: Maybe<Scalars["Boolean"]>;
  lastFour?: Maybe<Scalars["String"]>;
  paypalEmail?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
};

export type RecurlySubscription = {
  __typename?: "RecurlySubscription";
  billingAmount?: Maybe<Scalars["Int"]>;
  cancelAtPeriodEnd?: Maybe<Scalars["Boolean"]>;
  currentPeriodEnd?: Maybe<Scalars["UnixTimestampSec"]>;
  discountAmount?: Maybe<Scalars["Int"]>;
  isOnFreeTrial?: Maybe<Scalars["Boolean"]>;
  planInterval?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  trialEndsAt?: Maybe<Scalars["UnixTimestampSec"]>;
  unitAmount?: Maybe<Scalars["Int"]>;
};

export type RecurlyUpcomingInvoice = {
  __typename?: "RecurlyUpcomingInvoice";
  chargeAmount?: Maybe<Scalars["Int"]>;
  error?: Maybe<Scalars["String"]>;
  nextPaymentAttempt?: Maybe<Scalars["UnixTimestampSec"]>;
  subtotal?: Maybe<Scalars["Int"]>;
};

export type RiotId = {
  tagLine: Scalars["String"];
  username: Scalars["String"];
};

export type RiotIdBySummonerName = {
  __typename?: "RiotIdBySummonerName";
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
};

export type RiotIdOutput = {
  __typename?: "RiotIdOutput";
  tagLine: Scalars["String"];
  username: Scalars["String"];
};

export type RiotVerification = {
  __typename?: "RiotVerification";
  iconId: Scalars["String"];
};

export type RoleData = {
  __typename?: "RoleData";
  games?: Maybe<Scalars["Int"]>;
  roleName?: Maybe<Scalars["String"]>;
  wins?: Maybe<Scalars["Int"]>;
};

export type RoleRates = {
  __typename?: "RoleRates";
  adc?: Maybe<Scalars["Float"]>;
  all?: Maybe<Scalars["Float"]>;
  jungle?: Maybe<Scalars["Float"]>;
  mid?: Maybe<Scalars["Float"]>;
  none?: Maybe<Scalars["Float"]>;
  supp?: Maybe<Scalars["Float"]>;
  top?: Maybe<Scalars["Float"]>;
};

export type RootMutationType = {
  __typename?: "RootMutationType";
  addRecurlyPaymentMethod?: Maybe<AddPaymentMethodResult>;
  cancelRecurlySubscription?: Maybe<CancelSubscriptionResponse>;
  confirmPayment?: Maybe<Status>;
  deleteRecurlyPaymentMethod?: Maybe<StatusWithError>;
  deleteUser?: Maybe<Status>;
  premiumSignup?: Maybe<Status>;
  premiumSignupPayments?: Maybe<BraintreeSubscription>;
  premiumSignupRecurly?: Maybe<SubscriptionStatus>;
  reactivateRecurlySubscription?: Maybe<SubscriptionStatus>;
  register?: Maybe<LoginState>;
  resubscribeUser?: Maybe<Status>;
  setDefaultRecurlyPaymentMethod?: Maybe<StatusWithError>;
  setHeaderBg?: Maybe<Status>;
  setProfileCustomizations?: Maybe<CustomizationData>;
  unsubscribeUser?: Maybe<Status>;
  updateBilling?: Maybe<Status>;
  updateEmail?: Maybe<LoginState>;
  updatePassword?: Maybe<Status>;
  updatePremiumPlan?: Maybe<Status>;
  updateRecurlyPaymentMethod?: Maybe<AddPaymentMethodResult>;
  updateSettings?: Maybe<Settings>;
  updateSubscriptionPayment?: Maybe<BraintreeSubscription>;
  userFeedback?: Maybe<Status>;
  userFeedbackCmsWebsite?: Maybe<Status>;
  userFeedbackDeadlockWebsite?: Maybe<Status>;
  userFeedbackWebsite?: Maybe<Status>;
  userFeedbackWowWebsite?: Maybe<Status>;
  verify?: Maybe<Status>;
};

export type RootMutationTypeAddRecurlyPaymentMethodArgs = {
  recurlyToken: Scalars["String"];
};

export type RootMutationTypeConfirmPaymentArgs = {
  paymentIntentId: Scalars["String"];
  paymentType: Scalars["String"];
};

export type RootMutationTypeDeleteUserArgs = {
  email: Scalars["String"];
  password: Scalars["String"];
};

export type RootMutationTypePremiumSignupArgs = {
  addressCity?: InputMaybe<Scalars["String"]>;
  addressCountry?: InputMaybe<Scalars["String"]>;
  addressLineOne?: InputMaybe<Scalars["String"]>;
  addressLineTwo?: InputMaybe<Scalars["String"]>;
  addressState?: InputMaybe<Scalars["String"]>;
  addressZip?: InputMaybe<Scalars["String"]>;
  brand: Scalars["String"];
  currency?: InputMaybe<Scalars["String"]>;
  expMonth: Scalars["Int"];
  expYear: Scalars["Int"];
  last4: Scalars["String"];
  name: Scalars["String"];
  planDurationMonths?: Scalars["Int"];
  stripeToken: Scalars["String"];
};

export type RootMutationTypePremiumSignupPaymentsArgs = {
  paymentMethodNonce?: InputMaybe<Scalars["String"]>;
  planDurationMonths?: Scalars["Int"];
  recaptchaToken: Scalars["String"];
  recaptchaVersion: Scalars["String"];
};

export type RootMutationTypePremiumSignupRecurlyArgs = {
  currency?: Scalars["String"];
  planId: Scalars["String"];
  recaptchaToken: Scalars["String"];
  recaptchaVersion: Scalars["String"];
  recurlyToken: Scalars["String"];
};

export type RootMutationTypeReactivateRecurlySubscriptionArgs = {
  recaptchaToken: Scalars["String"];
  recaptchaVersion: Scalars["String"];
  recurlyToken: Scalars["String"];
};

export type RootMutationTypeRegisterArgs = {
  agreementSigned: Scalars["Boolean"];
  email: Scalars["String"];
  marketingOptOut: Scalars["Boolean"];
  password: Scalars["String"];
  primarySummoner: InputSummoner;
};

export type RootMutationTypeSetDefaultRecurlyPaymentMethodArgs = {
  recurlyToken: Scalars["String"];
};

export type RootMutationTypeSetHeaderBgArgs = {
  headerBg: Scalars["String"];
};

export type RootMutationTypeSetProfileCustomizationsArgs = {
  headerBg?: InputMaybe<Scalars["String"]>;
  pinnedMatchId?: InputMaybe<Scalars["String"]>;
  regionId?: InputMaybe<Scalars["String"]>;
  riotTagLine?: InputMaybe<Scalars["String"]>;
  riotUserName?: InputMaybe<Scalars["String"]>;
  twitchLink?: InputMaybe<Scalars["String"]>;
  twitchName?: InputMaybe<Scalars["String"]>;
  twitterLink?: InputMaybe<Scalars["String"]>;
  twitterName?: InputMaybe<Scalars["String"]>;
  youtubeLink?: InputMaybe<Scalars["String"]>;
  youtubeName?: InputMaybe<Scalars["String"]>;
};

export type RootMutationTypeUpdateBillingArgs = {
  addressCity?: InputMaybe<Scalars["String"]>;
  addressCountry?: InputMaybe<Scalars["String"]>;
  addressLineOne?: InputMaybe<Scalars["String"]>;
  addressLineTwo?: InputMaybe<Scalars["String"]>;
  addressState?: InputMaybe<Scalars["String"]>;
  addressZip: Scalars["String"];
  brand: Scalars["String"];
  expMonth: Scalars["Int"];
  expYear: Scalars["Int"];
  last4: Scalars["String"];
  name: Scalars["String"];
  stripeToken: Scalars["String"];
};

export type RootMutationTypeUpdateEmailArgs = {
  newEmail: Scalars["String"];
  oldEmail: Scalars["String"];
  password: Scalars["String"];
};

export type RootMutationTypeUpdatePasswordArgs = {
  newPassword: Scalars["String"];
  password?: InputMaybe<Scalars["String"]>;
  passwordResetHash?: InputMaybe<Scalars["String"]>;
};

export type RootMutationTypeUpdatePremiumPlanArgs = {
  currency?: InputMaybe<Scalars["String"]>;
  planDurationMonths?: Scalars["Int"];
};

export type RootMutationTypeUpdateRecurlyPaymentMethodArgs = {
  recurlyToken: Scalars["String"];
};

export type RootMutationTypeUpdateSettingsArgs = {
  birthdayDay?: InputMaybe<Scalars["Int"]>;
  birthdayMonth?: InputMaybe<Scalars["Int"]>;
  birthdayYear?: InputMaybe<Scalars["Int"]>;
  favoriteChampions?: InputMaybe<Array<InputMaybe<InputChampion>>>;
  favoriteSummoners?: InputMaybe<Array<InputMaybe<InputSummoner>>>;
  filterBuildsAndRunes?: InputMaybe<InputFilterBuildsAndRunes>;
  filterProBuilds?: InputMaybe<InputFilterProBuilds>;
  filterTierList?: InputMaybe<InputFilterTierList>;
  firstName?: InputMaybe<Scalars["String"]>;
  lastName?: InputMaybe<Scalars["String"]>;
  marketingOptOut?: InputMaybe<Scalars["Boolean"]>;
  primarySummoner?: InputMaybe<InputSummoner>;
  primarySummoners?: InputMaybe<Array<InputMaybe<InputSummoner>>>;
  startDay?: InputMaybe<Scalars["Int"]>;
  startMonth?: InputMaybe<Scalars["Int"]>;
  startYear?: InputMaybe<Scalars["Int"]>;
};

export type RootMutationTypeUpdateSubscriptionPaymentArgs = {
  paymentMethodNonce?: InputMaybe<Scalars["String"]>;
};

export type RootMutationTypeUserFeedbackArgs = {
  attachments?: InputMaybe<Array<InputMaybe<Attachment>>>;
  content: Scalars["String"];
};

export type RootMutationTypeUserFeedbackCmsWebsiteArgs = {
  content: Scalars["String"];
};

export type RootMutationTypeUserFeedbackDeadlockWebsiteArgs = {
  content: Scalars["String"];
};

export type RootMutationTypeUserFeedbackWebsiteArgs = {
  content: Scalars["String"];
};

export type RootMutationTypeUserFeedbackWowWebsiteArgs = {
  content: Scalars["String"];
};

export type RootMutationTypeVerifyArgs = {
  verificationCode: Scalars["String"];
};

export type RootQueryType = {
  __typename?: "RootQueryType";
  bestAndWorstChampions?: Maybe<ProfileChampRankingsContainer>;
  crossRegionProfileSearch?: Maybe<Array<Maybe<ProfileRank>>>;
  fetchApBuild?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  fetchChampSelectTags?: Maybe<Array<Maybe<ChampSelectTags>>>;
  fetchMultipleSummonerTags?: Maybe<Array<Maybe<SummonerTags>>>;
  fetchPerformanceScore?: Maybe<Array<Maybe<PerformanceScore>>>;
  fetchPlayedWith?: Maybe<PlayedWith>;
  fetchPlayerLpTimeline?: Maybe<Array<Maybe<LpStat>>>;
  fetchPlayerMatchSummaries?: Maybe<PlayerMatchSummaries>;
  fetchPlayerStatistics?: Maybe<Array<Maybe<PlayerStatistics>>>;
  fetchPostgameTags?: Maybe<Array<Maybe<SummonerTags>>>;
  fetchPostgameTagsOld?: Maybe<Array<Maybe<SummonerTags>>>;
  fetchProfileRanks?: Maybe<PlayerRank>;
  fetchSummonerTags?: Maybe<TagList>;
  forgotPassword?: Maybe<Status>;
  generatePatchInReview?: Maybe<PatchInReviewStats>;
  generatePlayerChampionStats?: Maybe<PlayerChampionStats>;
  generatePlayerMatchLeadTimelineAverages?: Maybe<PlayerMatchLeadTimelineAveragesStats>;
  generatePlayerMatchTimelineAverages?: Maybe<PlayerMatchTimelineAveragesStats>;
  getBillingData?: Maybe<BillingData>;
  getBraintreeClientToken?: Maybe<BraintreeClientToken>;
  getChampionDamageBreakdown?: Maybe<ChampionDamageBreakdown>;
  getChampionOtpStats?: Maybe<Array<Maybe<ChampionOtpStats>>>;
  getChampionOtpStats2?: Maybe<Array<Maybe<ChampionOtpStats>>>;
  getCommonlyVersedOpponentChampions?: Maybe<Array<Maybe<SummonerOpponentChampionStat>>>;
  getFeaturedGames?: Maybe<FeaturedGames>;
  getHistoricRanks?: Maybe<Array<Maybe<HistoricPlayerRank>>>;
  getLatestProMatches?: Maybe<Array<Maybe<ProMatchSummary>>>;
  getLatestWorldsMatchList?: Maybe<Array<Maybe<ProMatchSummary>>>;
  getLiveGame?: Maybe<LiveGame>;
  getLiveGameDummy?: Maybe<LiveGame>;
  getMinuteByMinuteData?: Maybe<MinuteByMinuteData>;
  getMinuteByMinuteTierData?: Maybe<MinuteByMinuteData>;
  getMultisearch?: Maybe<Array<Maybe<Multisearch>>>;
  getOauthConnections?: Maybe<Array<Maybe<OauthConnection>>>;
  getOverallChampionStats?: Maybe<OverallChampionStats>;
  getPersonalTierList?: Maybe<Array<Maybe<BasicChampionPerformanceWithTier>>>;
  getPersonalTierListByChampRole?: Maybe<Array<Maybe<BasicChampionPerformanceWithTier>>>;
  getPlanPrices?: Maybe<Array<Maybe<PremiumPlanPrices>>>;
  getPlayerChampionStatsMaxAndAvgScores?: Maybe<PlayerChampionMaxAverageStats>;
  getPlayerMatchupStats?: Maybe<Array<Maybe<BasicChampionPerformance>>>;
  getPlayerMatchupStatsByChampRole?: Maybe<Array<Maybe<BasicChampionPerformance>>>;
  getPopularPros?: Maybe<Array<Maybe<PopularProInfo>>>;
  getProChampionMatchList?: Maybe<ProChampionMatchPage>;
  getProChampionRolePercentages?: Maybe<ProChampionRolePercentages>;
  getProChampionRunePercentages?: Maybe<Array<Maybe<ProChampionRunePercentage>>>;
  getProChampionSkillPriority?: Maybe<ProChampionSkillPriority>;
  getProChampionSpellPercentages?: Maybe<Array<Maybe<ProChampionSpellPercentage>>>;
  getProChampionWinRate?: Maybe<ProChampionWinRate>;
  getProMatch?: Maybe<ProMatch>;
  getProMatchList?: Maybe<Array<Maybe<ProMatchSummary>>>;
  getProRank?: Maybe<PlayerRank>;
  getProRankChampions?: Maybe<PlayerStatistics>;
  getProStatsRanking?: Maybe<ProStatsRanking>;
  getProTags?: Maybe<Array<Maybe<Scalars["String"]>>>;
  getRecommendation: Recommendation;
  getRecurlyBillingData?: Maybe<RecurlyBillingData>;
  getSettings?: Maybe<Settings>;
  getState?: Maybe<State>;
  getSummonerRankSnapshots?: Maybe<Array<Maybe<RankSnapshot>>>;
  getTopProChampionPicks?: Maybe<Array<Maybe<ProChampionPick>>>;
  getTopProsForChampion?: Maybe<Array<Maybe<ChampionTopPro>>>;
  lastTenWinrate?: Maybe<Array<Maybe<Winrate>>>;
  leaderboardPage?: Maybe<RankedLeaderboardPage>;
  lightMode?: Maybe<Status>;
  liveGameChampSelect?: Maybe<Array<Maybe<ChampSelectLiveGame>>>;
  liveGameExists?: Maybe<Scalars["Boolean"]>;
  liveGameTags?: Maybe<Array<Maybe<LiveGameTags>>>;
  login?: Maybe<State>;
  logout?: Maybe<Status>;
  match?: Maybe<Match>;
  overallRanking?: Maybe<SummonerRanking>;
  playerInfoSuggestions?: Maybe<Array<Maybe<PlayerInfo>>>;
  playerProfileSuggestions?: Maybe<Array<Maybe<ProfileSuggestion>>>;
  previewPremiumPlanChange?: Maybe<PlanChangePreview>;
  probuildUrl?: Maybe<Status>;
  profileInit?: Maybe<ProfileInit>;
  profileInitSimple?: Maybe<ProfileInitSimple>;
  profilePlayerInfo?: Maybe<PlayerInfo>;
  profilePlayerInfoOg?: Maybe<PlayerInfo>;
  recentRoleRates?: Maybe<RecentRoleRates>;
  requestRiotVerificationCode?: Maybe<RiotVerification>;
  reverifyEmail?: Maybe<Status>;
  riotIdBySummonerName?: Maybe<RiotIdBySummonerName>;
  twitchStreams?: Maybe<Array<Maybe<TwitchStreamsDesc>>>;
  uggApp?: Maybe<Status>;
  updatePlayerProfile?: Maybe<StatusWithErrorReason>;
  updatePrimarySummoner?: Maybe<Status>;
  upsertContact?: Maybe<StatusWithErrorReason>;
  upsertMarvelRivalsContact?: Maybe<Status>;
  url?: Maybe<Status>;
  usesRecurlySubscription?: Maybe<Status>;
  verifyRiotCode?: Maybe<Status>;
  yearInReviewDataRequest?: Maybe<Scalars["String"]>;
  yearInReviewStatusRequest?: Maybe<Scalars["String"]>;
  yearInReviewSubmission?: Maybe<Status>;
};

export type RootQueryTypeBestAndWorstChampionsArgs = {
  queueId: Scalars["Int"];
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
  roleId: Scalars["Int"];
};

export type RootQueryTypeCrossRegionProfileSearchArgs = {
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
};

export type RootQueryTypeFetchApBuildArgs = {
  build?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars["String"]>>>>>;
};

export type RootQueryTypeFetchChampSelectTagsArgs = {
  queueType: Scalars["String"];
  regionId: Scalars["String"];
  summonerName: Scalars["String"];
};

export type RootQueryTypeFetchMultipleSummonerTagsArgs = {
  championIds?: InputMaybe<Array<Scalars["Int"]>>;
  queueTypes?: InputMaybe<Array<Scalars["String"]>>;
  regionId: Scalars["String"];
  riotIds?: InputMaybe<Array<RiotId>>;
};

export type RootQueryTypeFetchPerformanceScoreArgs = {
  matchId: Scalars["String"];
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
  version: Scalars["String"];
};

export type RootQueryTypeFetchPlayedWithArgs = {
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
};

export type RootQueryTypeFetchPlayerLpTimelineArgs = {
  patchVersion: Scalars["String"];
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
  timeframe?: InputMaybe<Scalars["String"]>;
};

export type RootQueryTypeFetchPlayerMatchSummariesArgs = {
  championId?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
  duoRiotTagLine?: InputMaybe<Scalars["String"]>;
  duoRiotUserName?: InputMaybe<Scalars["String"]>;
  page?: InputMaybe<Scalars["Int"]>;
  processLp?: InputMaybe<Scalars["Boolean"]>;
  queueType?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
  role?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
  seasonIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

export type RootQueryTypeFetchPlayerStatisticsArgs = {
  queueType?: InputMaybe<Array<Scalars["Int"]>>;
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
  role: Scalars["Int"];
  seasonId: Scalars["Int"];
};

export type RootQueryTypeFetchPostgameTagsArgs = {
  matchId: Scalars["Int"];
  regionId: Scalars["String"];
  version: Scalars["String"];
};

export type RootQueryTypeFetchPostgameTagsOldArgs = {
  matchId: Scalars["Int"];
  regionId: Scalars["String"];
  version: Scalars["String"];
};

export type RootQueryTypeFetchProfileRanksArgs = {
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
  seasonId: Scalars["Int"];
};

export type RootQueryTypeFetchSummonerTagsArgs = {
  championId: Scalars["Int"];
  queueType: Scalars["String"];
  regionId: Scalars["String"];
  summonerName: Scalars["String"];
};

export type RootQueryTypeForgotPasswordArgs = {
  debug?: InputMaybe<Scalars["String"]>;
  email: Scalars["String"];
};

export type RootQueryTypeGeneratePatchInReviewArgs = {
  patchVersion: Scalars["String"];
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
};

export type RootQueryTypeGeneratePlayerChampionStatsArgs = {
  championId: Scalars["Int"];
  queueId?: Scalars["Int"];
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
  role?: InputMaybe<Scalars["Int"]>;
  seasonId: Scalars["Int"];
};

export type RootQueryTypeGeneratePlayerMatchLeadTimelineAveragesArgs = {
  championId?: InputMaybe<Scalars["Int"]>;
  patchVersion?: InputMaybe<Scalars["String"]>;
  queueId?: InputMaybe<Scalars["Int"]>;
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
  role?: InputMaybe<Scalars["Int"]>;
  seasonId?: InputMaybe<Scalars["Int"]>;
};

export type RootQueryTypeGeneratePlayerMatchTimelineAveragesArgs = {
  championId?: InputMaybe<Scalars["Int"]>;
  patchVersion?: InputMaybe<Scalars["String"]>;
  queueId?: InputMaybe<Scalars["Int"]>;
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
  role?: InputMaybe<Scalars["Int"]>;
  seasonId?: InputMaybe<Scalars["Int"]>;
};

export type RootQueryTypeGetChampionDamageBreakdownArgs = {
  championId: Scalars["Int"];
  queueType: Scalars["String"];
  role: Scalars["Int"];
};

export type RootQueryTypeGetChampionOtpStatsArgs = {
  championId: Scalars["Int"];
};

export type RootQueryTypeGetChampionOtpStats2Args = {
  championId: Scalars["Int"];
  regionId?: InputMaybe<Scalars["String"]>;
};

export type RootQueryTypeGetCommonlyVersedOpponentChampionsArgs = {
  championId: Scalars["Int"];
  queueId?: Scalars["Int"];
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
  role?: InputMaybe<Scalars["Int"]>;
  seasonId: Scalars["Int"];
};

export type RootQueryTypeGetFeaturedGamesArgs = {
  regionId: Scalars["String"];
};

export type RootQueryTypeGetHistoricRanksArgs = {
  queueType?: InputMaybe<Scalars["Int"]>;
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
};

export type RootQueryTypeGetLatestProMatchesArgs = {
  numMatches?: Scalars["Int"];
  proLeague?: InputMaybe<Scalars["String"]>;
  role?: InputMaybe<Scalars["String"]>;
};

export type RootQueryTypeGetLatestWorldsMatchListArgs = {
  championId?: InputMaybe<Scalars["Int"]>;
  isOtp?: InputMaybe<Scalars["Boolean"]>;
  isWorlds?: InputMaybe<Scalars["Boolean"]>;
  league?: InputMaybe<Scalars["String"]>;
  leagueBlocklist?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  opponentChampionId?: InputMaybe<Scalars["Int"]>;
  pageNumber?: InputMaybe<Scalars["Int"]>;
  proBlocklist?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  proTeam?: InputMaybe<Scalars["String"]>;
  recommendedFirst?: InputMaybe<Scalars["Boolean"]>;
  role?: InputMaybe<Scalars["String"]>;
  teamBlocklist?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  victoryOnly?: InputMaybe<Scalars["Boolean"]>;
};

export type RootQueryTypeGetLiveGameArgs = {
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
};

export type RootQueryTypeGetLiveGameDummyArgs = {
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
};

export type RootQueryTypeGetMinuteByMinuteDataArgs = {
  championId: Scalars["Int"];
  queueType: Scalars["String"];
  role: Scalars["String"];
};

export type RootQueryTypeGetMinuteByMinuteTierDataArgs = {
  championId: Scalars["Int"];
  queueType: Scalars["String"];
  role: Scalars["String"];
  tier: Scalars["String"];
};

export type RootQueryTypeGetMultisearchArgs = {
  regionId?: InputMaybe<Array<Scalars["String"]>>;
  riotTagLine?: InputMaybe<Array<Scalars["String"]>>;
  riotUserName?: InputMaybe<Array<Scalars["String"]>>;
};

export type RootQueryTypeGetOverallChampionStatsArgs = {
  championId: Scalars["Int"];
  queueId?: InputMaybe<Scalars["Int"]>;
  role?: InputMaybe<Scalars["Int"]>;
};

export type RootQueryTypeGetPersonalTierListArgs = {
  queueIds: Array<Scalars["Int"]>;
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
  role: Scalars["Int"];
};

export type RootQueryTypeGetPersonalTierListByChampRoleArgs = {
  championId: Scalars["Int"];
  queueIds: Scalars["Int"];
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
  role: Scalars["Int"];
};

export type RootQueryTypeGetPlanPricesArgs = {
  currency?: Scalars["String"];
};

export type RootQueryTypeGetPlayerChampionStatsMaxAndAvgScoresArgs = {
  championId: Scalars["Int"];
  queueId?: Scalars["Int"];
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
  role?: InputMaybe<Scalars["Int"]>;
  seasonId: Scalars["Int"];
};

export type RootQueryTypeGetPlayerMatchupStatsArgs = {
  queueType: Scalars["Int"];
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
};

export type RootQueryTypeGetPlayerMatchupStatsByChampRoleArgs = {
  championId: Scalars["Int"];
  queueType: Scalars["Int"];
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
  role: Scalars["Int"];
};

export type RootQueryTypeGetProChampionMatchListArgs = {
  championId?: InputMaybe<Scalars["Int"]>;
  isOtp?: InputMaybe<Scalars["Boolean"]>;
  isWorlds?: InputMaybe<Scalars["Boolean"]>;
  league?: InputMaybe<Scalars["String"]>;
  leagueBlocklist?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  opponentChampionId?: InputMaybe<Scalars["Int"]>;
  pageNumber?: InputMaybe<Scalars["Int"]>;
  proBlocklist?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  proTeam?: InputMaybe<Scalars["String"]>;
  recommendedFirst?: InputMaybe<Scalars["Boolean"]>;
  role?: InputMaybe<Scalars["String"]>;
  teamBlocklist?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  victoryOnly?: InputMaybe<Scalars["Boolean"]>;
};

export type RootQueryTypeGetProChampionRolePercentagesArgs = {
  championId: Scalars["Int"];
  isOtp?: InputMaybe<Scalars["Boolean"]>;
  isWorlds?: InputMaybe<Scalars["Boolean"]>;
  leagueId?: InputMaybe<Scalars["String"]>;
};

export type RootQueryTypeGetProChampionRunePercentagesArgs = {
  championId: Scalars["Int"];
  isOtp?: InputMaybe<Scalars["Boolean"]>;
  isWorlds?: InputMaybe<Scalars["Boolean"]>;
  leagueId?: InputMaybe<Scalars["String"]>;
  opponentChampionId?: InputMaybe<Scalars["Int"]>;
  role?: InputMaybe<Scalars["String"]>;
};

export type RootQueryTypeGetProChampionSkillPriorityArgs = {
  championId: Scalars["Int"];
  leagueId?: InputMaybe<Scalars["String"]>;
  opponentChampionId?: InputMaybe<Scalars["Int"]>;
  role?: InputMaybe<Scalars["String"]>;
};

export type RootQueryTypeGetProChampionSpellPercentagesArgs = {
  championId: Scalars["Int"];
  isOtp?: InputMaybe<Scalars["Boolean"]>;
  isWorlds?: InputMaybe<Scalars["Boolean"]>;
  leagueId?: InputMaybe<Scalars["String"]>;
  opponentChampionId?: InputMaybe<Scalars["Int"]>;
  role?: InputMaybe<Scalars["String"]>;
};

export type RootQueryTypeGetProChampionWinRateArgs = {
  championId: Scalars["Int"];
  isOtp?: InputMaybe<Scalars["Boolean"]>;
  isWorlds?: InputMaybe<Scalars["Boolean"]>;
  leagueId?: InputMaybe<Scalars["String"]>;
  opponentChampionId?: InputMaybe<Scalars["Int"]>;
  role?: InputMaybe<Scalars["String"]>;
};

export type RootQueryTypeGetProMatchArgs = {
  matchId: Scalars["Int"];
  regionId: Scalars["String"];
  version: Scalars["String"];
};

export type RootQueryTypeGetProMatchListArgs = {
  pageNumber?: InputMaybe<Scalars["Int"]>;
  proNormalizedName?: InputMaybe<Scalars["String"]>;
  recommendedFirst?: InputMaybe<Scalars["Boolean"]>;
  role?: InputMaybe<Scalars["String"]>;
  victoryOnly?: InputMaybe<Scalars["Boolean"]>;
};

export type RootQueryTypeGetProRankArgs = {
  normalizedName: Scalars["String"];
  regionId: Scalars["String"];
};

export type RootQueryTypeGetProRankChampionsArgs = {
  normalizedName: Scalars["String"];
  regionId: Scalars["String"];
};

export type RootQueryTypeGetProStatsRankingArgs = {
  normalizedName: Scalars["String"];
};

export type RootQueryTypeGetProTagsArgs = {
  normalizedName: Scalars["String"];
  regionId: Scalars["String"];
};

export type RootQueryTypeGetRecommendationArgs = {
  championId: Scalars["Int"];
  mmr: Scalars["String"];
  opponentChampionId: Scalars["Int"];
  queueType: Scalars["String"];
  regionId: Scalars["String"];
  role: Scalars["String"];
  version: Scalars["String"];
};

export type RootQueryTypeGetSummonerRankSnapshotsArgs = {
  queueType?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
};

export type RootQueryTypeGetTopProChampionPicksArgs = {
  version?: InputMaybe<Scalars["String"]>;
};

export type RootQueryTypeGetTopProsForChampionArgs = {
  championId: Scalars["Int"];
};

export type RootQueryTypeLastTenWinrateArgs = {
  championIds: Array<InputMaybe<Scalars["Int"]>>;
  queueType: Scalars["String"];
  regionId: Scalars["String"];
  riotIds?: InputMaybe<Array<RiotId>>;
  roles: Array<InputMaybe<Scalars["Int"]>>;
};

export type RootQueryTypeLeaderboardPageArgs = {
  page?: InputMaybe<Scalars["Int"]>;
  queueType?: InputMaybe<Scalars["Int"]>;
  regionId: Scalars["String"];
};

export type RootQueryTypeLightModeArgs = {
  enabled: Scalars["Boolean"];
};

export type RootQueryTypeLiveGameChampSelectArgs = {
  queueId: Scalars["Int"];
  regionId: Scalars["String"];
  riotIds: Array<RiotId>;
};

export type RootQueryTypeLiveGameExistsArgs = {
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
};

export type RootQueryTypeLiveGameTagsArgs = {
  queueId: Scalars["Int"];
  regionId: Scalars["String"];
  summoners: Array<InputMaybe<LiveGameSummoner>>;
};

export type RootQueryTypeLoginArgs = {
  email: Scalars["String"];
  password: Scalars["String"];
};

export type RootQueryTypeMatchArgs = {
  matchId: Scalars["String"];
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
  version: Scalars["String"];
};

export type RootQueryTypeOverallRankingArgs = {
  queueType?: InputMaybe<Scalars["Int"]>;
  regionId?: InputMaybe<Scalars["String"]>;
  riotTagLine?: InputMaybe<Scalars["String"]>;
  riotUserName?: InputMaybe<Scalars["String"]>;
};

export type RootQueryTypePlayerInfoSuggestionsArgs = {
  query: Scalars["String"];
  regionId: Scalars["String"];
};

export type RootQueryTypePlayerProfileSuggestionsArgs = {
  query: Scalars["String"];
  regionId: Scalars["String"];
};

export type RootQueryTypePreviewPremiumPlanChangeArgs = {
  currency?: InputMaybe<Scalars["String"]>;
  planDurationMonths?: Scalars["Int"];
};

export type RootQueryTypeProbuildUrlArgs = {
  anonId?: InputMaybe<Scalars["String"]>;
  url: Scalars["String"];
};

export type RootQueryTypeProfileInitArgs = {
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
};

export type RootQueryTypeProfileInitSimpleArgs = {
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
};

export type RootQueryTypeProfilePlayerInfoArgs = {
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
};

export type RootQueryTypeProfilePlayerInfoOgArgs = {
  regionId: Scalars["String"];
  riotTagline: Scalars["String"];
  riotUserName: Scalars["String"];
};

export type RootQueryTypeRecentRoleRatesArgs = {
  queueType: Scalars["Int"];
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
};

export type RootQueryTypeReverifyEmailArgs = {
  debug?: InputMaybe<Scalars["String"]>;
};

export type RootQueryTypeRiotIdBySummonerNameArgs = {
  regionId: Scalars["String"];
  summonerName: Scalars["String"];
};

export type RootQueryTypeTwitchStreamsArgs = {
  game: Scalars["String"];
};

export type RootQueryTypeUggAppArgs = {
  appVersion?: InputMaybe<Scalars["String"]>;
  logInfo: Scalars["String"];
  logType: Scalars["String"];
};

export type RootQueryTypeUpdatePlayerProfileArgs = {
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
};

export type RootQueryTypeUpdatePrimarySummonerArgs = {
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
};

export type RootQueryTypeUpsertContactArgs = {
  email: Scalars["String"];
  game: Scalars["String"];
};

export type RootQueryTypeUpsertMarvelRivalsContactArgs = {
  email: Scalars["String"];
};

export type RootQueryTypeUrlArgs = {
  anonId?: InputMaybe<Scalars["String"]>;
  url: Scalars["String"];
};

export type RootQueryTypeYearInReviewDataRequestArgs = {
  assignedSeason: Scalars["String"];
  regionId: Scalars["String"];
  riotTagline: Scalars["String"];
  riotUsername: Scalars["String"];
};

export type RootQueryTypeYearInReviewStatusRequestArgs = {
  assignedSeason: Scalars["String"];
  regionId: Scalars["String"];
  riotTagline: Scalars["String"];
  riotUsername: Scalars["String"];
};

export type RootQueryTypeYearInReviewSubmissionArgs = {
  season: Scalars["Int"];
};

/** Recommended Runes. */
export type Runes = {
  __typename?: "Runes";
  allRunes: Array<Maybe<Scalars["Int"]>>;
  keystoneMastery: Scalars["Int"];
  matches: Scalars["Int"];
  primaryStyle: Scalars["Int"];
  subStyle: Scalars["Int"];
  wins: Scalars["Int"];
};

export type SeasonOverallStat = {
  __typename?: "SeasonOverallStat";
  patchVersion?: Maybe<Scalars["String"]>;
  quantity?: Maybe<Scalars["Int"]>;
};

export type Settings = {
  __typename?: "Settings";
  billingSettings?: Maybe<BillingSettings>;
  birthdayDay?: Maybe<Scalars["Int"]>;
  birthdayMonth?: Maybe<Scalars["Int"]>;
  birthdayYear?: Maybe<Scalars["Int"]>;
  email: Scalars["String"];
  filterDefaults?: Maybe<FilterDefaults>;
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  lolSettings?: Maybe<LolSettings>;
  marketingOptOut: Scalars["Boolean"];
  startDay?: Maybe<Scalars["Int"]>;
  startMonth?: Maybe<Scalars["Int"]>;
  startYear?: Maybe<Scalars["Int"]>;
  uggFavoriteFeature?: Maybe<Scalars["String"]>;
};

export type SkillOrder = {
  __typename?: "SkillOrder";
  matches: Scalars["Int"];
  skillPath: Array<Maybe<Scalars["Int"]>>;
  skillPriority: Array<Maybe<Scalars["Int"]>>;
  wins: Scalars["Int"];
};

export type StartingBuild = {
  __typename?: "StartingBuild";
  items: Array<Maybe<Scalars["Int"]>>;
  matches: Scalars["Int"];
  wins: Scalars["Int"];
};

export type StatDifferenceFrame = {
  __typename?: "StatDifferenceFrame";
  oppValue?: Maybe<Scalars["Int"]>;
  timestamp?: Maybe<Scalars["Int"]>;
  youValue?: Maybe<Scalars["Int"]>;
};

export type State = {
  __typename?: "State";
  email: Scalars["String"];
  filterDefaults?: Maybe<FilterDefaults>;
  firstName: Scalars["String"];
  googleAnalyticsId?: Maybe<Scalars["String"]>;
  isVerified: Scalars["Boolean"];
  lastName: Scalars["String"];
  loginState?: Maybe<LoginState>;
  lolSettings: LolSettings;
  premium: Premium;
};

export type Status = {
  __typename?: "Status";
  success?: Maybe<Scalars["Boolean"]>;
};

export type StatusWithError = {
  __typename?: "StatusWithError";
  error?: Maybe<Scalars["String"]>;
  success?: Maybe<Scalars["Boolean"]>;
};

export type StatusWithErrorReason = {
  __typename?: "StatusWithErrorReason";
  errorReason?: Maybe<Scalars["String"]>;
  success?: Maybe<Scalars["Boolean"]>;
};

export type SubscriptionInfo = {
  __typename?: "SubscriptionInfo";
  cancelAtPeriodEnd?: Maybe<Scalars["Boolean"]>;
  currentPeriodEnd?: Maybe<Scalars["UnixTimestampSec"]>;
  status?: Maybe<Scalars["String"]>;
};

export type SubscriptionStatus = {
  __typename?: "SubscriptionStatus";
  currentPeriodEndsAt?: Maybe<Scalars["UnixTimestampSec"]>;
  error?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
  isTrialSubscription: Scalars["Boolean"];
  success: Scalars["Boolean"];
  trialEndsAt?: Maybe<Scalars["UnixTimestampSec"]>;
};

export type Summoner = {
  __typename?: "Summoner";
  iconId?: Maybe<Scalars["String"]>;
  iconUrl?: Maybe<Scalars["String"]>;
  isDefault?: Maybe<Scalars["Boolean"]>;
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
  verified?: Maybe<Scalars["Boolean"]>;
};

export type SummonerChampionStats = {
  __typename?: "SummonerChampionStats";
  flex?: Maybe<Array<Maybe<ChampionStat>>>;
  solo?: Maybe<Array<Maybe<ChampionStat>>>;
};

export type SummonerLpStats = {
  __typename?: "SummonerLpStats";
  flex?: Maybe<LpStat>;
  solo?: Maybe<LpStat>;
};

export type SummonerOpponentChampionStat = {
  __typename?: "SummonerOpponentChampionStat";
  opponentChampion?: Maybe<Scalars["Int"]>;
  totalLossesAgainst?: Maybe<Scalars["Int"]>;
  totalWinsAgainst?: Maybe<Scalars["Int"]>;
  winRate?: Maybe<Scalars["Float"]>;
};

export type SummonerOverallStats = {
  __typename?: "SummonerOverallStats";
  goldLeadAtFifteen?: Maybe<Scalars["Int"]>;
  goldLeadAtFifteenChampionId?: Maybe<Scalars["Int"]>;
  largeMonstersKilled?: Maybe<Scalars["Int"]>;
  largestComeback?: Maybe<Scalars["Int"]>;
  largestComebackChampionId?: Maybe<Scalars["Int"]>;
  largestLead?: Maybe<Scalars["Int"]>;
  largestLeadChampionId?: Maybe<Scalars["Int"]>;
  longestKillStreak?: Maybe<Scalars["Int"]>;
  longestKillStreakChampionId?: Maybe<Scalars["Int"]>;
  mostDamageDealt?: Maybe<Scalars["Int"]>;
  mostDamageDealtChampionId?: Maybe<Scalars["Int"]>;
  shortestMatch?: Maybe<Scalars["Int"]>;
  shortestMatchChampionId?: Maybe<Scalars["Int"]>;
  totalDoubleKills?: Maybe<Scalars["Int"]>;
  totalPentaKills?: Maybe<Scalars["Int"]>;
  totalQuadraKills?: Maybe<Scalars["Int"]>;
  totalTripleKills?: Maybe<Scalars["Int"]>;
  winRate?: Maybe<Scalars["Float"]>;
  xpLeadAtFifteen?: Maybe<Scalars["Int"]>;
  xpLeadAtFifteenChampionId?: Maybe<Scalars["Int"]>;
};

export type SummonerRanking = {
  __typename?: "SummonerRanking";
  overallRanking?: Maybe<Scalars["Int"]>;
  totalPlayerCount?: Maybe<Scalars["Int"]>;
};

export type SummonerSeasonOverallStats = {
  __typename?: "SummonerSeasonOverallStats";
  goldLeadAtFifteen?: Maybe<SeasonOverallStat>;
  largestComeback?: Maybe<SeasonOverallStat>;
  largestLead?: Maybe<SeasonOverallStat>;
  longestKillStreak?: Maybe<SeasonOverallStat>;
  mostDamageDealt?: Maybe<SeasonOverallStat>;
  shortestMatch?: Maybe<SeasonOverallStat>;
  xpLeadAtFifteen?: Maybe<SeasonOverallStat>;
};

/** Summoner Spells. (Flash, Ignite) */
export type SummonerSpells = {
  __typename?: "SummonerSpells";
  matches: Scalars["Int"];
  spells: Array<Maybe<Scalars["Int"]>>;
  wins: Scalars["Int"];
};

export type SummonerTags = {
  __typename?: "SummonerTags";
  premadeData?: Maybe<PremadeData>;
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
  tagList?: Maybe<Array<Maybe<Tag>>>;
};

export type SummonerTeamShareStats = {
  __typename?: "SummonerTeamShareStats";
  opponentDamagePercentage?: Maybe<Scalars["Float"]>;
  opponentGoldPercentage?: Maybe<Scalars["Float"]>;
  opponentVisionScorePercentage?: Maybe<Scalars["Float"]>;
  summonerDamagePercentage?: Maybe<Scalars["Float"]>;
  summonerGoldPercentage?: Maybe<Scalars["Float"]>;
  summonerVisionScorePercentage?: Maybe<Scalars["Float"]>;
};

export type SummonerWinPlayRates = {
  __typename?: "SummonerWinPlayRates";
  queueType?: Maybe<Scalars["String"]>;
  rolePlayRates?: Maybe<RoleRates>;
  roleWinRates?: Maybe<RoleRates>;
  totalGamesPlayed?: Maybe<Scalars["Int"]>;
  winRate?: Maybe<Scalars["Float"]>;
};

export type Tag = {
  __typename?: "Tag";
  category: Scalars["String"];
  meta: Scalars["String"];
  tag: Scalars["String"];
  type: Scalars["String"];
};

export type TagList = {
  __typename?: "TagList";
  tagList?: Maybe<Array<Maybe<Tag>>>;
};

export type TeamData = {
  __typename?: "TeamData";
  championId?: Maybe<Scalars["Int"]>;
  damage?: Maybe<Scalars["Int"]>;
  hardCarry?: Maybe<Scalars["Float"]>;
  placement?: Maybe<Scalars["Int"]>;
  playerRank?: Maybe<PlayerRank>;
  playerSubteamId?: Maybe<Scalars["Int"]>;
  riotTagLine?: Maybe<Scalars["String"]>;
  riotUserName?: Maybe<Scalars["String"]>;
  role?: Maybe<Scalars["Int"]>;
  summonerName?: Maybe<Scalars["String"]>;
  teamId?: Maybe<Scalars["Int"]>;
  teamplay?: Maybe<Scalars["Float"]>;
};

export type TeamOverview = {
  __typename?: "TeamOverview";
  bans?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  baronKills?: Maybe<Scalars["Int"]>;
  dragonKills?: Maybe<Scalars["Int"]>;
  gold?: Maybe<Scalars["Int"]>;
  inhibitorKills?: Maybe<Scalars["Int"]>;
  kills?: Maybe<Scalars["Int"]>;
  riftHeraldKills?: Maybe<Scalars["Int"]>;
  towerKills?: Maybe<Scalars["Int"]>;
};

export type TimelineData = {
  __typename?: "TimelineData";
  assistPids?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  assistRiotIds?: Maybe<Array<Maybe<RiotIdOutput>>>;
  buildingType?: Maybe<Scalars["String"]>;
  eventType?: Maybe<Scalars["String"]>;
  killerId?: Maybe<Scalars["Int"]>;
  killerIds?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  laneType?: Maybe<Scalars["String"]>;
  monsterSubtype?: Maybe<Scalars["String"]>;
  monsterType?: Maybe<Scalars["String"]>;
  pid?: Maybe<Scalars["Int"]>;
  position?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  riotTagLine?: Maybe<Scalars["String"]>;
  riotUserName?: Maybe<Scalars["String"]>;
  teamId?: Maybe<Scalars["Int"]>;
  timestamp?: Maybe<Scalars["Int"]>;
  towerType?: Maybe<Scalars["String"]>;
  victimId?: Maybe<Scalars["Int"]>;
  victimRiotTagLine?: Maybe<Scalars["String"]>;
  victimRiotUserName?: Maybe<Scalars["String"]>;
  wardType?: Maybe<Scalars["String"]>;
};

export type TwitchStreamsDesc = {
  __typename?: "TwitchStreamsDesc";
  gameId?: Maybe<Scalars["String"]>;
  gameName?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
  isMature?: Maybe<Scalars["String"]>;
  language?: Maybe<Scalars["String"]>;
  profileImageUrl?: Maybe<Scalars["String"]>;
  startedAt?: Maybe<Scalars["String"]>;
  tagIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
  tags?: Maybe<Array<Maybe<Scalars["String"]>>>;
  thumbnailUrl?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  userId?: Maybe<Scalars["String"]>;
  userLogin?: Maybe<Scalars["String"]>;
  userName?: Maybe<Scalars["String"]>;
  viewerCount?: Maybe<Scalars["Int"]>;
};

export type UpcomingInvoice = {
  __typename?: "UpcomingInvoice";
  chargeAmount?: Maybe<Scalars["Int"]>;
  error?: Maybe<Scalars["String"]>;
  nextPaymentAttempt?: Maybe<Scalars["Int"]>;
  subtotal?: Maybe<Scalars["Int"]>;
};

export type Winrate = {
  __typename?: "Winrate";
  gameList?: Maybe<Scalars["String"]>;
  riotTagLine?: Maybe<Scalars["String"]>;
  riotUserName?: Maybe<Scalars["String"]>;
  totalGames?: Maybe<Scalars["Int"]>;
};

export type WinsLosses = {
  __typename?: "WinsLosses";
  matches: Scalars["Int"];
  wins: Scalars["Int"];
};

export type UsesRecurlySubscriptionQueryVariables = Exact<{ [key: string]: never }>;

export type UsesRecurlySubscriptionQuery = {
  __typename?: "RootQueryType";
  usesRecurlySubscription?: { __typename?: "Status"; success?: boolean | null } | null;
};

export type GetRecurlyBillingDataQueryVariables = Exact<{ [key: string]: never }>;

export type GetRecurlyBillingDataQuery = {
  __typename?: "RootQueryType";
  getRecurlyBillingData?: {
    __typename?: "RecurlyBillingData";
    invoices?: Array<{
      __typename?: "RecurlyInvoice";
      currency?: string | null;
      paid?: boolean | null;
      brand?: string | null;
      last4?: string | null;
      periodStart?: any | null;
      periodEnd?: any | null;
      totalPaid?: number | null;
    } | null> | null;
    subscription?: {
      __typename?: "RecurlySubscription";
      status?: string | null;
      cancelAtPeriodEnd?: boolean | null;
      currentPeriodEnd?: any | null;
      planInterval?: string | null;
      unitAmount?: number | null;
      isOnFreeTrial?: boolean | null;
      trialEndsAt?: any | null;
    } | null;
    paymentMethods?: Array<{
      __typename?: "RecurlyPaymentMethodDetail";
      id?: string | null;
      type?: string | null;
      isDefault?: boolean | null;
      cardType?: string | null;
      lastFour?: string | null;
      paypalEmail?: string | null;
    } | null> | null;
    upcomingInvoice?: {
      __typename?: "RecurlyUpcomingInvoice";
      chargeAmount?: number | null;
      subtotal?: number | null;
      error?: string | null;
      nextPaymentAttempt?: any | null;
    } | null;
  } | null;
};

export type GetPremiumPlanPricesQueryVariables = Exact<{
  currency?: InputMaybe<Scalars["String"]>;
}>;

export type GetPremiumPlanPricesQuery = {
  __typename?: "RootQueryType";
  getPlanPrices?: Array<{
    __typename?: "PremiumPlanPrices";
    amount?: number | null;
    currency?: string | null;
    planDuration?: number | null;
    planId?: string | null;
    hasFreeTrial?: boolean | null;
    trialLength?: number | null;
    trialUnit?: string | null;
    hasBoostDiscount?: boolean | null;
    boostDiscountAmount?: number | null;
    boostDiscountPercent?: number | null;
    originalPrice?: number | null;
    recurringPrice?: number | null;
  } | null> | null;
};

export type StartRecurlySubscriptionMutationVariables = Exact<{
  planId: Scalars["String"];
  recurlyToken: Scalars["String"];
  recaptchaToken: Scalars["String"];
  recaptchaVersion: Scalars["String"];
}>;

export type StartRecurlySubscriptionMutation = {
  __typename?: "RootMutationType";
  premiumSignupRecurly?: { __typename?: "SubscriptionStatus"; success: boolean; error?: string | null } | null;
};

export type CancelRecurlySubscriptionMutationVariables = Exact<{ [key: string]: never }>;

export type CancelRecurlySubscriptionMutation = {
  __typename?: "RootMutationType";
  cancelRecurlySubscription?: { __typename?: "CancelSubscriptionResponse"; success: boolean; error?: string | null } | null;
};

export type SetDefaultRecurlyPaymentMethodMutationVariables = Exact<{
  recurlyToken: Scalars["String"];
}>;

export type SetDefaultRecurlyPaymentMethodMutation = {
  __typename?: "RootMutationType";
  setDefaultRecurlyPaymentMethod?: { __typename?: "StatusWithError"; success?: boolean | null; error?: string | null } | null;
};

export type UpdateRecurlyPaymentMethodMutationVariables = Exact<{
  recurlyToken: Scalars["String"];
}>;

export type UpdateRecurlyPaymentMethodMutation = {
  __typename?: "RootMutationType";
  updateRecurlyPaymentMethod?: {
    __typename?: "AddPaymentMethodResult";
    success?: boolean | null;
    error?: string | null;
    paymentMethod?: {
      __typename?: "RecurlyPaymentMethod";
      id?: string | null;
      type?: string | null;
      isDefault?: boolean | null;
      cardType?: string | null;
      lastFour?: string | null;
      paypalEmail?: string | null;
    } | null;
  } | null;
};

export type AddRecurlyPaymentMethodMutationVariables = Exact<{
  recurlyToken: Scalars["String"];
}>;

export type AddRecurlyPaymentMethodMutation = {
  __typename?: "RootMutationType";
  addRecurlyPaymentMethod?: {
    __typename?: "AddPaymentMethodResult";
    success?: boolean | null;
    error?: string | null;
    paymentMethod?: {
      __typename?: "RecurlyPaymentMethod";
      id?: string | null;
      type?: string | null;
      isDefault?: boolean | null;
      cardType?: string | null;
      lastFour?: string | null;
      paypalEmail?: string | null;
    } | null;
  } | null;
};

export type DeleteRecurlyPaymentMethodMutationVariables = Exact<{ [key: string]: never }>;

export type DeleteRecurlyPaymentMethodMutation = {
  __typename?: "RootMutationType";
  deleteRecurlyPaymentMethod?: { __typename?: "StatusWithError"; success?: boolean | null; error?: string | null } | null;
};

export type ReactivateRecurlySubscriptionMutationVariables = Exact<{
  recurlyToken: Scalars["String"];
  recaptchaToken: Scalars["String"];
  recaptchaVersion: Scalars["String"];
}>;

export type ReactivateRecurlySubscriptionMutation = {
  __typename?: "RootMutationType";
  reactivateRecurlySubscription?: { __typename?: "SubscriptionStatus"; success: boolean; error?: string | null } | null;
};

export type GetProChampionMatchListQueryVariables = Exact<{
  championId?: InputMaybe<Scalars["Int"]>;
  league?: InputMaybe<Scalars["String"]>;
  recommendedFirst?: InputMaybe<Scalars["Boolean"]>;
  role?: InputMaybe<Scalars["String"]>;
  victoryOnly?: InputMaybe<Scalars["Boolean"]>;
  opponentChampionId?: InputMaybe<Scalars["Int"]>;
  leagueBlocklist?: InputMaybe<Array<InputMaybe<Scalars["String"]>> | InputMaybe<Scalars["String"]>>;
  teamBlocklist?: InputMaybe<Array<InputMaybe<Scalars["String"]>> | InputMaybe<Scalars["String"]>>;
  proBlocklist?: InputMaybe<Array<InputMaybe<Scalars["String"]>> | InputMaybe<Scalars["String"]>>;
  pageNumber?: InputMaybe<Scalars["Int"]>;
  isWorlds?: InputMaybe<Scalars["Boolean"]>;
  isOtp?: InputMaybe<Scalars["Boolean"]>;
  proTeam?: InputMaybe<Scalars["String"]>;
}>;

export type GetProChampionMatchListQuery = {
  __typename?: "RootQueryType";
  getProChampionMatchList?: {
    __typename?: "ProChampionMatchPage";
    matchList?: Array<{
      __typename?: "ProMatchSummary";
      opponentChampionId: number;
      totalKills: number;
      totalDeaths: number;
      totalAssists: number;
      proInfo?: { __typename?: "ProInfo"; currentTeam: string; officialName: string } | null;
    } | null> | null;
  } | null;
};

export type UserFeedbackMutationVariables = Exact<{
  content: Scalars["String"];
  attachment?: InputMaybe<Attachment>;
}>;

export type UserFeedbackMutation = {
  __typename?: "RootMutationType";
  userFeedback?: { __typename?: "Status"; success?: boolean | null } | null;
};

export type UserFeedbackCmsMutationVariables = Exact<{
  content: Scalars["String"];
}>;

export type UserFeedbackCmsMutation = {
  __typename?: "RootMutationType";
  userFeedbackCmsWebsite?: { __typename?: "Status"; success?: boolean | null } | null;
};

export type FragBasicChampionPerformanceFragment = {
  __typename?: "BasicChampionPerformance";
  assists?: number | null;
  championId?: number | null;
  cs?: number | null;
  damage?: number | null;
  damageTaken?: number | null;
  deaths?: number | null;
  doubleKills?: number | null;
  gold?: number | null;
  kills?: number | null;
  lpAvg?: number | null;
  maxDeaths?: number | null;
  maxKills?: number | null;
  pentaKills?: number | null;
  quadraKills?: number | null;
  totalMatches?: number | null;
  tripleKills?: number | null;
  wins?: number | null;
  matchupStats?: Array<{
    __typename?: "MatchupStatistics";
    championId?: number | null;
    opponentChampionId?: number | null;
    role?: number | null;
    totalGames?: number | null;
    winSum?: number | null;
  } | null> | null;
};

export type GetPersonalTierListByChampRoleQueryVariables = Exact<{
  championId: Scalars["Int"];
  queueIds: Scalars["Int"];
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
  role: Scalars["Int"];
}>;

export type GetPersonalTierListByChampRoleQuery = {
  __typename?: "RootQueryType";
  getPersonalTierListByChampRole?: Array<{
    __typename?: "BasicChampionPerformanceWithTier";
    assists?: number | null;
    championId?: number | null;
    cs?: number | null;
    damage?: number | null;
    damageTaken?: number | null;
    deaths?: number | null;
    doubleKills?: number | null;
    gold?: number | null;
    kills?: number | null;
    lpAvg?: number | null;
    lpCount?: number | null;
    maxDeaths?: number | null;
    maxKills?: number | null;
    pentaKills?: number | null;
    quadraKills?: number | null;
    role?: number | null;
    tier?: string | null;
    totalMatches?: number | null;
    tripleKills?: number | null;
    visionScore?: number | null;
    wins?: number | null;
    zScore?: number | null;
    pickRate?: number | null;
  } | null> | null;
};

export type GetPersonalTierListQueryVariables = Exact<{
  queueIds: Array<Scalars["Int"]> | Scalars["Int"];
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
  role: Scalars["Int"];
}>;

export type GetPersonalTierListQuery = {
  __typename?: "RootQueryType";
  getPersonalTierList?: Array<{
    __typename?: "BasicChampionPerformanceWithTier";
    assists?: number | null;
    championId?: number | null;
    cs?: number | null;
    damage?: number | null;
    damageTaken?: number | null;
    deaths?: number | null;
    doubleKills?: number | null;
    gold?: number | null;
    kills?: number | null;
    lpAvg?: number | null;
    lpCount?: number | null;
    maxDeaths?: number | null;
    maxKills?: number | null;
    pentaKills?: number | null;
    quadraKills?: number | null;
    role?: number | null;
    tier?: string | null;
    totalMatches?: number | null;
    tripleKills?: number | null;
    visionScore?: number | null;
    wins?: number | null;
    zScore?: number | null;
  } | null> | null;
};

export type GetPlayerMatchupStatsQueryVariables = Exact<{
  queueType: Scalars["Int"];
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
}>;

export type GetPlayerMatchupStatsQuery = {
  __typename?: "RootQueryType";
  getPlayerMatchupStats?: Array<{
    __typename?: "BasicChampionPerformance";
    assists?: number | null;
    championId?: number | null;
    cs?: number | null;
    damage?: number | null;
    damageTaken?: number | null;
    deaths?: number | null;
    doubleKills?: number | null;
    gold?: number | null;
    kills?: number | null;
    lpAvg?: number | null;
    maxDeaths?: number | null;
    maxKills?: number | null;
    pentaKills?: number | null;
    quadraKills?: number | null;
    totalMatches?: number | null;
    tripleKills?: number | null;
    wins?: number | null;
    matchupStats?: Array<{
      __typename?: "MatchupStatistics";
      championId?: number | null;
      opponentChampionId?: number | null;
      role?: number | null;
      totalGames?: number | null;
      winSum?: number | null;
    } | null> | null;
  } | null> | null;
};

export type GetPlayerMatchupStatsByChampRoleQueryVariables = Exact<{
  championId: Scalars["Int"];
  queueType: Scalars["Int"];
  regionId: Scalars["String"];
  riotTagLine: Scalars["String"];
  riotUserName: Scalars["String"];
  role: Scalars["Int"];
}>;

export type GetPlayerMatchupStatsByChampRoleQuery = {
  __typename?: "RootQueryType";
  getPlayerMatchupStatsByChampRole?: Array<{
    __typename?: "BasicChampionPerformance";
    assists?: number | null;
    championId?: number | null;
    cs?: number | null;
    damage?: number | null;
    damageTaken?: number | null;
    deaths?: number | null;
    doubleKills?: number | null;
    gold?: number | null;
    kills?: number | null;
    lpAvg?: number | null;
    maxDeaths?: number | null;
    maxKills?: number | null;
    pentaKills?: number | null;
    quadraKills?: number | null;
    totalMatches?: number | null;
    tripleKills?: number | null;
    wins?: number | null;
    matchupStats?: Array<{
      __typename?: "MatchupStatistics";
      championId?: number | null;
      opponentChampionId?: number | null;
      role?: number | null;
      totalGames?: number | null;
      winSum?: number | null;
    } | null> | null;
  } | null> | null;
};

export type SetHeaderBgMutationVariables = Exact<{
  headerBg: Scalars["String"];
}>;

export type SetHeaderBgMutation = {
  __typename?: "RootMutationType";
  setHeaderBg?: { __typename?: "Status"; success?: boolean | null } | null;
};

export type SetProfileCustomizationsMutationVariables = Exact<{
  regionId?: InputMaybe<Scalars["String"]>;
  riotUserName?: InputMaybe<Scalars["String"]>;
  riotTagLine?: InputMaybe<Scalars["String"]>;
  headerBg?: InputMaybe<Scalars["String"]>;
  twitchName?: InputMaybe<Scalars["String"]>;
  twitterName?: InputMaybe<Scalars["String"]>;
  youtubeName?: InputMaybe<Scalars["String"]>;
}>;

export type SetProfileCustomizationsMutation = {
  __typename?: "RootMutationType";
  setProfileCustomizations?: {
    __typename?: "CustomizationData";
    headerBg?: string | null;
    twitchName?: string | null;
    twitterName?: string | null;
    youtubeName?: string | null;
  } | null;
};

export type FragLoginStateFragment = {
  __typename?: "State";
  firstName: string;
  lastName: string;
  email: string;
  isVerified: boolean;
  googleAnalyticsId?: string | null;
  loginState?: { __typename?: "LoginState"; token: string } | null;
  lolSettings: {
    __typename?: "LolSettings";
    summoners?: Array<{
      __typename?: "Summoner";
      isDefault?: boolean | null;
      regionId: string;
      riotUserName: string;
      riotTagLine: string;
      verified?: boolean | null;
      iconUrl?: string | null;
      iconId?: string | null;
    } | null> | null;
    favoriteChampions?: Array<{ __typename?: "Champion"; championId: number } | null> | null;
    favoriteSummoners?: Array<{
      __typename?: "Summoner";
      regionId: string;
      riotUserName: string;
      riotTagLine: string;
      iconUrl?: string | null;
      iconId?: string | null;
    } | null> | null;
  };
  filterDefaults?: {
    __typename?: "FilterDefaults";
    filterTierList?: {
      __typename?: "FilterTierList";
      mmr?: string | null;
      queueType?: string | null;
      regionId?: string | null;
      role?: string | null;
      showAllChampions?: boolean | null;
    } | null;
    filterBuildsAndRunes?: {
      __typename?: "FilterBuildsAndRunes";
      mmr?: string | null;
      queueType?: string | null;
      regionId?: string | null;
    } | null;
  } | null;
  premium: {
    __typename?: "Premium";
    isPremium: boolean;
    premiumVersion?: string | null;
    hasFailedPayment?: boolean | null;
    hasLegacyBoost?: boolean | null;
    paymentFailureDate?: any | null;
  };
};

export type UserStateQueryVariables = Exact<{ [key: string]: never }>;

export type UserStateQuery = {
  __typename?: "RootQueryType";
  getState?: {
    __typename?: "State";
    firstName: string;
    lastName: string;
    email: string;
    isVerified: boolean;
    googleAnalyticsId?: string | null;
    loginState?: { __typename?: "LoginState"; token: string } | null;
    lolSettings: {
      __typename?: "LolSettings";
      summoners?: Array<{
        __typename?: "Summoner";
        isDefault?: boolean | null;
        regionId: string;
        riotUserName: string;
        riotTagLine: string;
        verified?: boolean | null;
        iconUrl?: string | null;
        iconId?: string | null;
      } | null> | null;
      favoriteChampions?: Array<{ __typename?: "Champion"; championId: number } | null> | null;
      favoriteSummoners?: Array<{
        __typename?: "Summoner";
        regionId: string;
        riotUserName: string;
        riotTagLine: string;
        iconUrl?: string | null;
        iconId?: string | null;
      } | null> | null;
    };
    filterDefaults?: {
      __typename?: "FilterDefaults";
      filterTierList?: {
        __typename?: "FilterTierList";
        mmr?: string | null;
        queueType?: string | null;
        regionId?: string | null;
        role?: string | null;
        showAllChampions?: boolean | null;
      } | null;
      filterBuildsAndRunes?: {
        __typename?: "FilterBuildsAndRunes";
        mmr?: string | null;
        queueType?: string | null;
        regionId?: string | null;
      } | null;
    } | null;
    premium: {
      __typename?: "Premium";
      isPremium: boolean;
      premiumVersion?: string | null;
      hasFailedPayment?: boolean | null;
      hasLegacyBoost?: boolean | null;
      paymentFailureDate?: any | null;
    };
  } | null;
};

export const FragBasicChampionPerformanceFragmentDoc = gql`
  fragment fragBasicChampionPerformance on BasicChampionPerformance {
    assists
    championId
    cs
    damage
    damageTaken
    deaths
    doubleKills
    gold
    kills
    lpAvg
    maxDeaths
    maxKills
    pentaKills
    quadraKills
    totalMatches
    tripleKills
    wins
    matchupStats {
      championId
      opponentChampionId
      role
      totalGames
      winSum
    }
  }
`;
export const FragLoginStateFragmentDoc = gql`
  fragment fragLoginState on State {
    firstName
    lastName
    email
    isVerified
    googleAnalyticsId
    loginState {
      token
    }
    lolSettings {
      summoners {
        isDefault
        regionId
        riotUserName
        riotTagLine
        verified
        iconUrl
        iconId
      }
      favoriteChampions {
        championId
      }
      favoriteSummoners {
        regionId
        riotUserName
        riotTagLine
        iconUrl
        iconId
      }
    }
    filterDefaults {
      filterTierList {
        mmr
        queueType
        regionId
        role
        showAllChampions
      }
      filterBuildsAndRunes {
        mmr
        queueType
        regionId
      }
    }
    premium {
      isPremium
      premiumVersion
      hasFailedPayment
      hasLegacyBoost
      paymentFailureDate
    }
  }
`;
export const UsesRecurlySubscriptionDocument = gql`
  query usesRecurlySubscription {
    usesRecurlySubscription {
      success
    }
  }
`;

/**
 * __useUsesRecurlySubscriptionQuery__
 *
 * To run a query within a React component, call `useUsesRecurlySubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsesRecurlySubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsesRecurlySubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsesRecurlySubscriptionQuery(
  baseOptions?: Apollo.QueryHookOptions<UsesRecurlySubscriptionQuery, UsesRecurlySubscriptionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UsesRecurlySubscriptionQuery, UsesRecurlySubscriptionQueryVariables>(
    UsesRecurlySubscriptionDocument,
    options,
  );
}
export function useUsesRecurlySubscriptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UsesRecurlySubscriptionQuery, UsesRecurlySubscriptionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UsesRecurlySubscriptionQuery, UsesRecurlySubscriptionQueryVariables>(
    UsesRecurlySubscriptionDocument,
    options,
  );
}
export type UsesRecurlySubscriptionQueryHookResult = ReturnType<typeof useUsesRecurlySubscriptionQuery>;
export type UsesRecurlySubscriptionLazyQueryHookResult = ReturnType<typeof useUsesRecurlySubscriptionLazyQuery>;
export type UsesRecurlySubscriptionQueryResult = Apollo.QueryResult<
  UsesRecurlySubscriptionQuery,
  UsesRecurlySubscriptionQueryVariables
>;
export const GetRecurlyBillingDataDocument = gql`
  query getRecurlyBillingData {
    getRecurlyBillingData {
      invoices {
        currency
        paid
        brand
        last4
        periodStart
        periodEnd
        totalPaid
      }
      subscription {
        status
        cancelAtPeriodEnd
        currentPeriodEnd
        planInterval
        unitAmount
        isOnFreeTrial
        trialEndsAt
      }
      paymentMethods {
        id
        type
        isDefault
        cardType
        lastFour
        paypalEmail
      }
      upcomingInvoice {
        chargeAmount
        subtotal
        error
        nextPaymentAttempt
      }
    }
  }
`;

/**
 * __useGetRecurlyBillingDataQuery__
 *
 * To run a query within a React component, call `useGetRecurlyBillingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecurlyBillingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecurlyBillingDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRecurlyBillingDataQuery(
  baseOptions?: Apollo.QueryHookOptions<GetRecurlyBillingDataQuery, GetRecurlyBillingDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRecurlyBillingDataQuery, GetRecurlyBillingDataQueryVariables>(GetRecurlyBillingDataDocument, options);
}
export function useGetRecurlyBillingDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRecurlyBillingDataQuery, GetRecurlyBillingDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRecurlyBillingDataQuery, GetRecurlyBillingDataQueryVariables>(
    GetRecurlyBillingDataDocument,
    options,
  );
}
export type GetRecurlyBillingDataQueryHookResult = ReturnType<typeof useGetRecurlyBillingDataQuery>;
export type GetRecurlyBillingDataLazyQueryHookResult = ReturnType<typeof useGetRecurlyBillingDataLazyQuery>;
export type GetRecurlyBillingDataQueryResult = Apollo.QueryResult<
  GetRecurlyBillingDataQuery,
  GetRecurlyBillingDataQueryVariables
>;
export const GetPremiumPlanPricesDocument = gql`
  query getPremiumPlanPrices($currency: String) {
    getPlanPrices(currency: $currency) {
      amount
      currency
      planDuration
      planId
      hasFreeTrial
      trialLength
      trialUnit
      hasBoostDiscount
      boostDiscountAmount
      boostDiscountPercent
      originalPrice
      recurringPrice
    }
  }
`;

/**
 * __useGetPremiumPlanPricesQuery__
 *
 * To run a query within a React component, call `useGetPremiumPlanPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPremiumPlanPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPremiumPlanPricesQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetPremiumPlanPricesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetPremiumPlanPricesQuery, GetPremiumPlanPricesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPremiumPlanPricesQuery, GetPremiumPlanPricesQueryVariables>(GetPremiumPlanPricesDocument, options);
}
export function useGetPremiumPlanPricesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPremiumPlanPricesQuery, GetPremiumPlanPricesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPremiumPlanPricesQuery, GetPremiumPlanPricesQueryVariables>(
    GetPremiumPlanPricesDocument,
    options,
  );
}
export type GetPremiumPlanPricesQueryHookResult = ReturnType<typeof useGetPremiumPlanPricesQuery>;
export type GetPremiumPlanPricesLazyQueryHookResult = ReturnType<typeof useGetPremiumPlanPricesLazyQuery>;
export type GetPremiumPlanPricesQueryResult = Apollo.QueryResult<GetPremiumPlanPricesQuery, GetPremiumPlanPricesQueryVariables>;
export const StartRecurlySubscriptionDocument = gql`
  mutation startRecurlySubscription(
    $planId: String!
    $recurlyToken: String!
    $recaptchaToken: String!
    $recaptchaVersion: String!
  ) {
    premiumSignupRecurly(
      planId: $planId
      recurlyToken: $recurlyToken
      recaptchaToken: $recaptchaToken
      recaptchaVersion: $recaptchaVersion
    ) {
      success
      error
    }
  }
`;
export type StartRecurlySubscriptionMutationFn = Apollo.MutationFunction<
  StartRecurlySubscriptionMutation,
  StartRecurlySubscriptionMutationVariables
>;

/**
 * __useStartRecurlySubscriptionMutation__
 *
 * To run a mutation, you first call `useStartRecurlySubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartRecurlySubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startRecurlySubscriptionMutation, { data, loading, error }] = useStartRecurlySubscriptionMutation({
 *   variables: {
 *      planId: // value for 'planId'
 *      recurlyToken: // value for 'recurlyToken'
 *      recaptchaToken: // value for 'recaptchaToken'
 *      recaptchaVersion: // value for 'recaptchaVersion'
 *   },
 * });
 */
export function useStartRecurlySubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<StartRecurlySubscriptionMutation, StartRecurlySubscriptionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StartRecurlySubscriptionMutation, StartRecurlySubscriptionMutationVariables>(
    StartRecurlySubscriptionDocument,
    options,
  );
}
export type StartRecurlySubscriptionMutationHookResult = ReturnType<typeof useStartRecurlySubscriptionMutation>;
export type StartRecurlySubscriptionMutationResult = Apollo.MutationResult<StartRecurlySubscriptionMutation>;
export type StartRecurlySubscriptionMutationOptions = Apollo.BaseMutationOptions<
  StartRecurlySubscriptionMutation,
  StartRecurlySubscriptionMutationVariables
>;
export const CancelRecurlySubscriptionDocument = gql`
  mutation cancelRecurlySubscription {
    cancelRecurlySubscription {
      success
      error
    }
  }
`;
export type CancelRecurlySubscriptionMutationFn = Apollo.MutationFunction<
  CancelRecurlySubscriptionMutation,
  CancelRecurlySubscriptionMutationVariables
>;

/**
 * __useCancelRecurlySubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelRecurlySubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelRecurlySubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelRecurlySubscriptionMutation, { data, loading, error }] = useCancelRecurlySubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelRecurlySubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<CancelRecurlySubscriptionMutation, CancelRecurlySubscriptionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CancelRecurlySubscriptionMutation, CancelRecurlySubscriptionMutationVariables>(
    CancelRecurlySubscriptionDocument,
    options,
  );
}
export type CancelRecurlySubscriptionMutationHookResult = ReturnType<typeof useCancelRecurlySubscriptionMutation>;
export type CancelRecurlySubscriptionMutationResult = Apollo.MutationResult<CancelRecurlySubscriptionMutation>;
export type CancelRecurlySubscriptionMutationOptions = Apollo.BaseMutationOptions<
  CancelRecurlySubscriptionMutation,
  CancelRecurlySubscriptionMutationVariables
>;
export const SetDefaultRecurlyPaymentMethodDocument = gql`
  mutation setDefaultRecurlyPaymentMethod($recurlyToken: String!) {
    setDefaultRecurlyPaymentMethod(recurlyToken: $recurlyToken) {
      success
      error
    }
  }
`;
export type SetDefaultRecurlyPaymentMethodMutationFn = Apollo.MutationFunction<
  SetDefaultRecurlyPaymentMethodMutation,
  SetDefaultRecurlyPaymentMethodMutationVariables
>;

/**
 * __useSetDefaultRecurlyPaymentMethodMutation__
 *
 * To run a mutation, you first call `useSetDefaultRecurlyPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultRecurlyPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultRecurlyPaymentMethodMutation, { data, loading, error }] = useSetDefaultRecurlyPaymentMethodMutation({
 *   variables: {
 *      recurlyToken: // value for 'recurlyToken'
 *   },
 * });
 */
export function useSetDefaultRecurlyPaymentMethodMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDefaultRecurlyPaymentMethodMutation,
    SetDefaultRecurlyPaymentMethodMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetDefaultRecurlyPaymentMethodMutation, SetDefaultRecurlyPaymentMethodMutationVariables>(
    SetDefaultRecurlyPaymentMethodDocument,
    options,
  );
}
export type SetDefaultRecurlyPaymentMethodMutationHookResult = ReturnType<typeof useSetDefaultRecurlyPaymentMethodMutation>;
export type SetDefaultRecurlyPaymentMethodMutationResult = Apollo.MutationResult<SetDefaultRecurlyPaymentMethodMutation>;
export type SetDefaultRecurlyPaymentMethodMutationOptions = Apollo.BaseMutationOptions<
  SetDefaultRecurlyPaymentMethodMutation,
  SetDefaultRecurlyPaymentMethodMutationVariables
>;
export const UpdateRecurlyPaymentMethodDocument = gql`
  mutation updateRecurlyPaymentMethod($recurlyToken: String!) {
    updateRecurlyPaymentMethod(recurlyToken: $recurlyToken) {
      success
      error
      paymentMethod {
        id
        type
        isDefault
        cardType
        lastFour
        paypalEmail
      }
    }
  }
`;
export type UpdateRecurlyPaymentMethodMutationFn = Apollo.MutationFunction<
  UpdateRecurlyPaymentMethodMutation,
  UpdateRecurlyPaymentMethodMutationVariables
>;

/**
 * __useUpdateRecurlyPaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdateRecurlyPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecurlyPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecurlyPaymentMethodMutation, { data, loading, error }] = useUpdateRecurlyPaymentMethodMutation({
 *   variables: {
 *      recurlyToken: // value for 'recurlyToken'
 *   },
 * });
 */
export function useUpdateRecurlyPaymentMethodMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateRecurlyPaymentMethodMutation, UpdateRecurlyPaymentMethodMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateRecurlyPaymentMethodMutation, UpdateRecurlyPaymentMethodMutationVariables>(
    UpdateRecurlyPaymentMethodDocument,
    options,
  );
}
export type UpdateRecurlyPaymentMethodMutationHookResult = ReturnType<typeof useUpdateRecurlyPaymentMethodMutation>;
export type UpdateRecurlyPaymentMethodMutationResult = Apollo.MutationResult<UpdateRecurlyPaymentMethodMutation>;
export type UpdateRecurlyPaymentMethodMutationOptions = Apollo.BaseMutationOptions<
  UpdateRecurlyPaymentMethodMutation,
  UpdateRecurlyPaymentMethodMutationVariables
>;
export const AddRecurlyPaymentMethodDocument = gql`
  mutation addRecurlyPaymentMethod($recurlyToken: String!) {
    addRecurlyPaymentMethod(recurlyToken: $recurlyToken) {
      success
      error
      paymentMethod {
        id
        type
        isDefault
        cardType
        lastFour
        paypalEmail
      }
    }
  }
`;
export type AddRecurlyPaymentMethodMutationFn = Apollo.MutationFunction<
  AddRecurlyPaymentMethodMutation,
  AddRecurlyPaymentMethodMutationVariables
>;

/**
 * __useAddRecurlyPaymentMethodMutation__
 *
 * To run a mutation, you first call `useAddRecurlyPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRecurlyPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRecurlyPaymentMethodMutation, { data, loading, error }] = useAddRecurlyPaymentMethodMutation({
 *   variables: {
 *      recurlyToken: // value for 'recurlyToken'
 *   },
 * });
 */
export function useAddRecurlyPaymentMethodMutation(
  baseOptions?: Apollo.MutationHookOptions<AddRecurlyPaymentMethodMutation, AddRecurlyPaymentMethodMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddRecurlyPaymentMethodMutation, AddRecurlyPaymentMethodMutationVariables>(
    AddRecurlyPaymentMethodDocument,
    options,
  );
}
export type AddRecurlyPaymentMethodMutationHookResult = ReturnType<typeof useAddRecurlyPaymentMethodMutation>;
export type AddRecurlyPaymentMethodMutationResult = Apollo.MutationResult<AddRecurlyPaymentMethodMutation>;
export type AddRecurlyPaymentMethodMutationOptions = Apollo.BaseMutationOptions<
  AddRecurlyPaymentMethodMutation,
  AddRecurlyPaymentMethodMutationVariables
>;
export const DeleteRecurlyPaymentMethodDocument = gql`
  mutation deleteRecurlyPaymentMethod {
    deleteRecurlyPaymentMethod {
      success
      error
    }
  }
`;
export type DeleteRecurlyPaymentMethodMutationFn = Apollo.MutationFunction<
  DeleteRecurlyPaymentMethodMutation,
  DeleteRecurlyPaymentMethodMutationVariables
>;

/**
 * __useDeleteRecurlyPaymentMethodMutation__
 *
 * To run a mutation, you first call `useDeleteRecurlyPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRecurlyPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRecurlyPaymentMethodMutation, { data, loading, error }] = useDeleteRecurlyPaymentMethodMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteRecurlyPaymentMethodMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteRecurlyPaymentMethodMutation, DeleteRecurlyPaymentMethodMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteRecurlyPaymentMethodMutation, DeleteRecurlyPaymentMethodMutationVariables>(
    DeleteRecurlyPaymentMethodDocument,
    options,
  );
}
export type DeleteRecurlyPaymentMethodMutationHookResult = ReturnType<typeof useDeleteRecurlyPaymentMethodMutation>;
export type DeleteRecurlyPaymentMethodMutationResult = Apollo.MutationResult<DeleteRecurlyPaymentMethodMutation>;
export type DeleteRecurlyPaymentMethodMutationOptions = Apollo.BaseMutationOptions<
  DeleteRecurlyPaymentMethodMutation,
  DeleteRecurlyPaymentMethodMutationVariables
>;
export const ReactivateRecurlySubscriptionDocument = gql`
  mutation reactivateRecurlySubscription($recurlyToken: String!, $recaptchaToken: String!, $recaptchaVersion: String!) {
    reactivateRecurlySubscription(
      recurlyToken: $recurlyToken
      recaptchaToken: $recaptchaToken
      recaptchaVersion: $recaptchaVersion
    ) {
      success
      error
    }
  }
`;
export type ReactivateRecurlySubscriptionMutationFn = Apollo.MutationFunction<
  ReactivateRecurlySubscriptionMutation,
  ReactivateRecurlySubscriptionMutationVariables
>;

/**
 * __useReactivateRecurlySubscriptionMutation__
 *
 * To run a mutation, you first call `useReactivateRecurlySubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateRecurlySubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateRecurlySubscriptionMutation, { data, loading, error }] = useReactivateRecurlySubscriptionMutation({
 *   variables: {
 *      recurlyToken: // value for 'recurlyToken'
 *      recaptchaToken: // value for 'recaptchaToken'
 *      recaptchaVersion: // value for 'recaptchaVersion'
 *   },
 * });
 */
export function useReactivateRecurlySubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<ReactivateRecurlySubscriptionMutation, ReactivateRecurlySubscriptionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ReactivateRecurlySubscriptionMutation, ReactivateRecurlySubscriptionMutationVariables>(
    ReactivateRecurlySubscriptionDocument,
    options,
  );
}
export type ReactivateRecurlySubscriptionMutationHookResult = ReturnType<typeof useReactivateRecurlySubscriptionMutation>;
export type ReactivateRecurlySubscriptionMutationResult = Apollo.MutationResult<ReactivateRecurlySubscriptionMutation>;
export type ReactivateRecurlySubscriptionMutationOptions = Apollo.BaseMutationOptions<
  ReactivateRecurlySubscriptionMutation,
  ReactivateRecurlySubscriptionMutationVariables
>;
export const GetProChampionMatchListDocument = gql`
  query getProChampionMatchList(
    $championId: Int
    $league: String
    $recommendedFirst: Boolean
    $role: String
    $victoryOnly: Boolean
    $opponentChampionId: Int
    $leagueBlocklist: [String]
    $teamBlocklist: [String]
    $proBlocklist: [String]
    $pageNumber: Int
    $isWorlds: Boolean
    $isOtp: Boolean
    $proTeam: String
  ) {
    getProChampionMatchList(
      championId: $championId
      league: $league
      recommendedFirst: $recommendedFirst
      role: $role
      victoryOnly: $victoryOnly
      opponentChampionId: $opponentChampionId
      leagueBlocklist: $leagueBlocklist
      teamBlocklist: $teamBlocklist
      proBlocklist: $proBlocklist
      pageNumber: $pageNumber
      isWorlds: $isWorlds
      isOtp: $isOtp
      proTeam: $proTeam
    ) {
      matchList {
        opponentChampionId
        totalKills
        totalDeaths
        totalAssists
        proInfo {
          currentTeam
          officialName
        }
      }
    }
  }
`;

/**
 * __useGetProChampionMatchListQuery__
 *
 * To run a query within a React component, call `useGetProChampionMatchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProChampionMatchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProChampionMatchListQuery({
 *   variables: {
 *      championId: // value for 'championId'
 *      league: // value for 'league'
 *      recommendedFirst: // value for 'recommendedFirst'
 *      role: // value for 'role'
 *      victoryOnly: // value for 'victoryOnly'
 *      opponentChampionId: // value for 'opponentChampionId'
 *      leagueBlocklist: // value for 'leagueBlocklist'
 *      teamBlocklist: // value for 'teamBlocklist'
 *      proBlocklist: // value for 'proBlocklist'
 *      pageNumber: // value for 'pageNumber'
 *      isWorlds: // value for 'isWorlds'
 *      isOtp: // value for 'isOtp'
 *      proTeam: // value for 'proTeam'
 *   },
 * });
 */
export function useGetProChampionMatchListQuery(
  baseOptions?: Apollo.QueryHookOptions<GetProChampionMatchListQuery, GetProChampionMatchListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProChampionMatchListQuery, GetProChampionMatchListQueryVariables>(
    GetProChampionMatchListDocument,
    options,
  );
}
export function useGetProChampionMatchListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetProChampionMatchListQuery, GetProChampionMatchListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProChampionMatchListQuery, GetProChampionMatchListQueryVariables>(
    GetProChampionMatchListDocument,
    options,
  );
}
export type GetProChampionMatchListQueryHookResult = ReturnType<typeof useGetProChampionMatchListQuery>;
export type GetProChampionMatchListLazyQueryHookResult = ReturnType<typeof useGetProChampionMatchListLazyQuery>;
export type GetProChampionMatchListQueryResult = Apollo.QueryResult<
  GetProChampionMatchListQuery,
  GetProChampionMatchListQueryVariables
>;
export const UserFeedbackDocument = gql`
  mutation userFeedback($content: String!, $attachment: Attachment) {
    userFeedback(content: $content, attachments: [$attachment]) {
      success
    }
  }
`;
export type UserFeedbackMutationFn = Apollo.MutationFunction<UserFeedbackMutation, UserFeedbackMutationVariables>;

/**
 * __useUserFeedbackMutation__
 *
 * To run a mutation, you first call `useUserFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userFeedbackMutation, { data, loading, error }] = useUserFeedbackMutation({
 *   variables: {
 *      content: // value for 'content'
 *      attachment: // value for 'attachment'
 *   },
 * });
 */
export function useUserFeedbackMutation(
  baseOptions?: Apollo.MutationHookOptions<UserFeedbackMutation, UserFeedbackMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UserFeedbackMutation, UserFeedbackMutationVariables>(UserFeedbackDocument, options);
}
export type UserFeedbackMutationHookResult = ReturnType<typeof useUserFeedbackMutation>;
export type UserFeedbackMutationResult = Apollo.MutationResult<UserFeedbackMutation>;
export type UserFeedbackMutationOptions = Apollo.BaseMutationOptions<UserFeedbackMutation, UserFeedbackMutationVariables>;
export const UserFeedbackCmsDocument = gql`
  mutation userFeedbackCms($content: String!) {
    userFeedbackCmsWebsite(content: $content) {
      success
    }
  }
`;
export type UserFeedbackCmsMutationFn = Apollo.MutationFunction<UserFeedbackCmsMutation, UserFeedbackCmsMutationVariables>;

/**
 * __useUserFeedbackCmsMutation__
 *
 * To run a mutation, you first call `useUserFeedbackCmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserFeedbackCmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userFeedbackCmsMutation, { data, loading, error }] = useUserFeedbackCmsMutation({
 *   variables: {
 *      content: // value for 'content'
 *   },
 * });
 */
export function useUserFeedbackCmsMutation(
  baseOptions?: Apollo.MutationHookOptions<UserFeedbackCmsMutation, UserFeedbackCmsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UserFeedbackCmsMutation, UserFeedbackCmsMutationVariables>(UserFeedbackCmsDocument, options);
}
export type UserFeedbackCmsMutationHookResult = ReturnType<typeof useUserFeedbackCmsMutation>;
export type UserFeedbackCmsMutationResult = Apollo.MutationResult<UserFeedbackCmsMutation>;
export type UserFeedbackCmsMutationOptions = Apollo.BaseMutationOptions<
  UserFeedbackCmsMutation,
  UserFeedbackCmsMutationVariables
>;
export const GetPersonalTierListByChampRoleDocument = gql`
  query getPersonalTierListByChampRole(
    $championId: Int!
    $queueIds: Int!
    $regionId: String!
    $riotTagLine: String!
    $riotUserName: String!
    $role: Int!
  ) {
    getPersonalTierListByChampRole(
      championId: $championId
      queueIds: $queueIds
      regionId: $regionId
      riotTagLine: $riotTagLine
      riotUserName: $riotUserName
      role: $role
    ) {
      assists
      championId
      cs
      damage
      damageTaken
      deaths
      doubleKills
      gold
      kills
      lpAvg
      lpCount
      maxDeaths
      maxKills
      pentaKills
      quadraKills
      role
      tier
      totalMatches
      tripleKills
      visionScore
      wins
      zScore
      pickRate
    }
  }
`;

/**
 * __useGetPersonalTierListByChampRoleQuery__
 *
 * To run a query within a React component, call `useGetPersonalTierListByChampRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalTierListByChampRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalTierListByChampRoleQuery({
 *   variables: {
 *      championId: // value for 'championId'
 *      queueIds: // value for 'queueIds'
 *      regionId: // value for 'regionId'
 *      riotTagLine: // value for 'riotTagLine'
 *      riotUserName: // value for 'riotUserName'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useGetPersonalTierListByChampRoleQuery(
  baseOptions: Apollo.QueryHookOptions<GetPersonalTierListByChampRoleQuery, GetPersonalTierListByChampRoleQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPersonalTierListByChampRoleQuery, GetPersonalTierListByChampRoleQueryVariables>(
    GetPersonalTierListByChampRoleDocument,
    options,
  );
}
export function useGetPersonalTierListByChampRoleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPersonalTierListByChampRoleQuery, GetPersonalTierListByChampRoleQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPersonalTierListByChampRoleQuery, GetPersonalTierListByChampRoleQueryVariables>(
    GetPersonalTierListByChampRoleDocument,
    options,
  );
}
export type GetPersonalTierListByChampRoleQueryHookResult = ReturnType<typeof useGetPersonalTierListByChampRoleQuery>;
export type GetPersonalTierListByChampRoleLazyQueryHookResult = ReturnType<typeof useGetPersonalTierListByChampRoleLazyQuery>;
export type GetPersonalTierListByChampRoleQueryResult = Apollo.QueryResult<
  GetPersonalTierListByChampRoleQuery,
  GetPersonalTierListByChampRoleQueryVariables
>;
export const GetPersonalTierListDocument = gql`
  query getPersonalTierList($queueIds: [Int!]!, $regionId: String!, $riotTagLine: String!, $riotUserName: String!, $role: Int!) {
    getPersonalTierList(
      queueIds: $queueIds
      regionId: $regionId
      riotTagLine: $riotTagLine
      riotUserName: $riotUserName
      role: $role
    ) {
      assists
      championId
      cs
      damage
      damageTaken
      deaths
      doubleKills
      gold
      kills
      lpAvg
      lpCount
      maxDeaths
      maxKills
      pentaKills
      quadraKills
      role
      tier
      totalMatches
      tripleKills
      visionScore
      wins
      zScore
    }
  }
`;

/**
 * __useGetPersonalTierListQuery__
 *
 * To run a query within a React component, call `useGetPersonalTierListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalTierListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalTierListQuery({
 *   variables: {
 *      queueIds: // value for 'queueIds'
 *      regionId: // value for 'regionId'
 *      riotTagLine: // value for 'riotTagLine'
 *      riotUserName: // value for 'riotUserName'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useGetPersonalTierListQuery(
  baseOptions: Apollo.QueryHookOptions<GetPersonalTierListQuery, GetPersonalTierListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPersonalTierListQuery, GetPersonalTierListQueryVariables>(GetPersonalTierListDocument, options);
}
export function useGetPersonalTierListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPersonalTierListQuery, GetPersonalTierListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPersonalTierListQuery, GetPersonalTierListQueryVariables>(GetPersonalTierListDocument, options);
}
export type GetPersonalTierListQueryHookResult = ReturnType<typeof useGetPersonalTierListQuery>;
export type GetPersonalTierListLazyQueryHookResult = ReturnType<typeof useGetPersonalTierListLazyQuery>;
export type GetPersonalTierListQueryResult = Apollo.QueryResult<GetPersonalTierListQuery, GetPersonalTierListQueryVariables>;
export const GetPlayerMatchupStatsDocument = gql`
  query getPlayerMatchupStats($queueType: Int!, $regionId: String!, $riotTagLine: String!, $riotUserName: String!) {
    getPlayerMatchupStats(queueType: $queueType, regionId: $regionId, riotTagLine: $riotTagLine, riotUserName: $riotUserName) {
      ...fragBasicChampionPerformance
    }
  }
  ${FragBasicChampionPerformanceFragmentDoc}
`;

/**
 * __useGetPlayerMatchupStatsQuery__
 *
 * To run a query within a React component, call `useGetPlayerMatchupStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayerMatchupStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayerMatchupStatsQuery({
 *   variables: {
 *      queueType: // value for 'queueType'
 *      regionId: // value for 'regionId'
 *      riotTagLine: // value for 'riotTagLine'
 *      riotUserName: // value for 'riotUserName'
 *   },
 * });
 */
export function useGetPlayerMatchupStatsQuery(
  baseOptions: Apollo.QueryHookOptions<GetPlayerMatchupStatsQuery, GetPlayerMatchupStatsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPlayerMatchupStatsQuery, GetPlayerMatchupStatsQueryVariables>(GetPlayerMatchupStatsDocument, options);
}
export function useGetPlayerMatchupStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPlayerMatchupStatsQuery, GetPlayerMatchupStatsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPlayerMatchupStatsQuery, GetPlayerMatchupStatsQueryVariables>(
    GetPlayerMatchupStatsDocument,
    options,
  );
}
export type GetPlayerMatchupStatsQueryHookResult = ReturnType<typeof useGetPlayerMatchupStatsQuery>;
export type GetPlayerMatchupStatsLazyQueryHookResult = ReturnType<typeof useGetPlayerMatchupStatsLazyQuery>;
export type GetPlayerMatchupStatsQueryResult = Apollo.QueryResult<
  GetPlayerMatchupStatsQuery,
  GetPlayerMatchupStatsQueryVariables
>;
export const GetPlayerMatchupStatsByChampRoleDocument = gql`
  query getPlayerMatchupStatsByChampRole(
    $championId: Int!
    $queueType: Int!
    $regionId: String!
    $riotTagLine: String!
    $riotUserName: String!
    $role: Int!
  ) {
    getPlayerMatchupStatsByChampRole(
      championId: $championId
      queueType: $queueType
      regionId: $regionId
      riotTagLine: $riotTagLine
      riotUserName: $riotUserName
      role: $role
    ) {
      ...fragBasicChampionPerformance
    }
  }
  ${FragBasicChampionPerformanceFragmentDoc}
`;

/**
 * __useGetPlayerMatchupStatsByChampRoleQuery__
 *
 * To run a query within a React component, call `useGetPlayerMatchupStatsByChampRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayerMatchupStatsByChampRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayerMatchupStatsByChampRoleQuery({
 *   variables: {
 *      championId: // value for 'championId'
 *      queueType: // value for 'queueType'
 *      regionId: // value for 'regionId'
 *      riotTagLine: // value for 'riotTagLine'
 *      riotUserName: // value for 'riotUserName'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useGetPlayerMatchupStatsByChampRoleQuery(
  baseOptions: Apollo.QueryHookOptions<GetPlayerMatchupStatsByChampRoleQuery, GetPlayerMatchupStatsByChampRoleQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPlayerMatchupStatsByChampRoleQuery, GetPlayerMatchupStatsByChampRoleQueryVariables>(
    GetPlayerMatchupStatsByChampRoleDocument,
    options,
  );
}
export function useGetPlayerMatchupStatsByChampRoleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPlayerMatchupStatsByChampRoleQuery,
    GetPlayerMatchupStatsByChampRoleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPlayerMatchupStatsByChampRoleQuery, GetPlayerMatchupStatsByChampRoleQueryVariables>(
    GetPlayerMatchupStatsByChampRoleDocument,
    options,
  );
}
export type GetPlayerMatchupStatsByChampRoleQueryHookResult = ReturnType<typeof useGetPlayerMatchupStatsByChampRoleQuery>;
export type GetPlayerMatchupStatsByChampRoleLazyQueryHookResult = ReturnType<typeof useGetPlayerMatchupStatsByChampRoleLazyQuery>;
export type GetPlayerMatchupStatsByChampRoleQueryResult = Apollo.QueryResult<
  GetPlayerMatchupStatsByChampRoleQuery,
  GetPlayerMatchupStatsByChampRoleQueryVariables
>;
export const SetHeaderBgDocument = gql`
  mutation setHeaderBg($headerBg: String!) {
    setHeaderBg(headerBg: $headerBg) {
      success
    }
  }
`;
export type SetHeaderBgMutationFn = Apollo.MutationFunction<SetHeaderBgMutation, SetHeaderBgMutationVariables>;

/**
 * __useSetHeaderBgMutation__
 *
 * To run a mutation, you first call `useSetHeaderBgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetHeaderBgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setHeaderBgMutation, { data, loading, error }] = useSetHeaderBgMutation({
 *   variables: {
 *      headerBg: // value for 'headerBg'
 *   },
 * });
 */
export function useSetHeaderBgMutation(
  baseOptions?: Apollo.MutationHookOptions<SetHeaderBgMutation, SetHeaderBgMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetHeaderBgMutation, SetHeaderBgMutationVariables>(SetHeaderBgDocument, options);
}
export type SetHeaderBgMutationHookResult = ReturnType<typeof useSetHeaderBgMutation>;
export type SetHeaderBgMutationResult = Apollo.MutationResult<SetHeaderBgMutation>;
export type SetHeaderBgMutationOptions = Apollo.BaseMutationOptions<SetHeaderBgMutation, SetHeaderBgMutationVariables>;
export const SetProfileCustomizationsDocument = gql`
  mutation setProfileCustomizations(
    $regionId: String
    $riotUserName: String
    $riotTagLine: String
    $headerBg: String
    $twitchName: String
    $twitterName: String
    $youtubeName: String
  ) {
    setProfileCustomizations(
      regionId: $regionId
      riotUserName: $riotUserName
      riotTagLine: $riotTagLine
      headerBg: $headerBg
      twitchLink: ""
      twitchName: $twitchName
      twitterLink: ""
      twitterName: $twitterName
      youtubeLink: ""
      youtubeName: $youtubeName
      pinnedMatchId: "0"
    ) {
      headerBg
      twitchName
      twitterName
      youtubeName
    }
  }
`;
export type SetProfileCustomizationsMutationFn = Apollo.MutationFunction<
  SetProfileCustomizationsMutation,
  SetProfileCustomizationsMutationVariables
>;

/**
 * __useSetProfileCustomizationsMutation__
 *
 * To run a mutation, you first call `useSetProfileCustomizationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProfileCustomizationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProfileCustomizationsMutation, { data, loading, error }] = useSetProfileCustomizationsMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      riotUserName: // value for 'riotUserName'
 *      riotTagLine: // value for 'riotTagLine'
 *      headerBg: // value for 'headerBg'
 *      twitchName: // value for 'twitchName'
 *      twitterName: // value for 'twitterName'
 *      youtubeName: // value for 'youtubeName'
 *   },
 * });
 */
export function useSetProfileCustomizationsMutation(
  baseOptions?: Apollo.MutationHookOptions<SetProfileCustomizationsMutation, SetProfileCustomizationsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetProfileCustomizationsMutation, SetProfileCustomizationsMutationVariables>(
    SetProfileCustomizationsDocument,
    options,
  );
}
export type SetProfileCustomizationsMutationHookResult = ReturnType<typeof useSetProfileCustomizationsMutation>;
export type SetProfileCustomizationsMutationResult = Apollo.MutationResult<SetProfileCustomizationsMutation>;
export type SetProfileCustomizationsMutationOptions = Apollo.BaseMutationOptions<
  SetProfileCustomizationsMutation,
  SetProfileCustomizationsMutationVariables
>;
export const UserStateDocument = gql`
  query userState {
    getState {
      ...fragLoginState
    }
  }
  ${FragLoginStateFragmentDoc}
`;

/**
 * __useUserStateQuery__
 *
 * To run a query within a React component, call `useUserStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserStateQuery(baseOptions?: Apollo.QueryHookOptions<UserStateQuery, UserStateQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserStateQuery, UserStateQueryVariables>(UserStateDocument, options);
}
export function useUserStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserStateQuery, UserStateQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserStateQuery, UserStateQueryVariables>(UserStateDocument, options);
}
export type UserStateQueryHookResult = ReturnType<typeof useUserStateQuery>;
export type UserStateLazyQueryHookResult = ReturnType<typeof useUserStateLazyQuery>;
export type UserStateQueryResult = Apollo.QueryResult<UserStateQuery, UserStateQueryVariables>;
